import { openBlock as e, createElementBlock as r, createElementVNode as o, createStaticVNode as s } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function i(n, t) {
  return e(), r("svg", l, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M1.75 13h22.5M13 1.75v22.5" })
    ], -1)
  ])]);
}
const Ee = { render: i }, c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function a(n, t) {
  return e(), r("svg", c, [...t[0] || (t[0] = [
    s('<g fill="none" fill-rule="evenodd"><path fill="currentColor" d="M21 13c-5.334 1.473-6.527 2.666-8 7.999-1.473-5.333-2.666-6.526-8-8 5.334-1.473 6.527-2.666 8-7.999 1.473 5.333 2.666 6.526 8 8"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M21 13c-5.334 1.473-6.527 2.666-8 7.999-1.473-5.333-2.666-6.526-8-8 5.334-1.473 6.527-2.666 8-7.999 1.473 5.333 2.666 6.526 8 8" data-icon-stroke="" style="--icon-sw:1px;stroke-width:calc(1px*max(26px/100cqw,26px/100cqh));"></path><path fill="currentColor" d="M24.75 4.75c-2.334.645-2.856 1.167-3.5 3.5-.645-2.333-1.167-2.855-3.5-3.5 2.333-.644 2.855-1.166 3.5-3.5.644 2.334 1.166 2.856 3.5 3.5"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M24.75 4.75c-2.334.645-2.856 1.167-3.5 3.5-.645-2.333-1.167-2.855-3.5-3.5 2.333-.644 2.855-1.166 3.5-3.5.644 2.334 1.166 2.856 3.5 3.5" data-icon-stroke="" style="--icon-sw:1px;stroke-width:calc(1px*max(26px/100cqw,26px/100cqh));"></path></g>', 1)
  ])]);
}
const Ge = { render: a }, h = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function p(n, t) {
  return e(), r("svg", h, [...t[0] || (t[0] = [
    s('<g fill="none" fill-rule="evenodd" transform="translate(1 1)"><circle cx="12" cy="12" r="12" fill="#DC3C3F"></circle><g stroke="#FFF" stroke-width="1.5" transform="translate(11.5 4.1)" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"><circle cx=".502" cy="14.482" r="1" fill="#FFF"></circle><path d="M.5 10.036V0"></path></g></g>', 1)
  ])]);
}
const Oe = { render: p }, d = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function x(n, t) {
  return e(), r("svg", d, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M13.25 20.75a.375.375 0 0 1 0-.75M13.25 20.75a.375.375 0 0 0 0-.75M13.25 17V9.5" }),
      o("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M14.87 3.01a1.81 1.81 0 0 0-2.576-.737 1.8 1.8 0 0 0-.665.737L2.156 22.308A1.52 1.52 0 0 0 3.522 24.5h19.456a1.53 1.53 0 0 0 1.292-.717 1.52 1.52 0 0 0 .074-1.475z"
      })
    ], -1)
  ])]);
}
const Pe = { render: x }, w = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function v(n, t) {
  return e(), r("svg", w, [...t[0] || (t[0] = [
    s('<g fill="none" fill-rule="evenodd"><path fill="#F2C2C3" stroke="#F2C2C3" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13 24.25c6.213 0 11.25-5.037 11.25-11.25S19.213 1.75 13 1.75 1.75 6.787 1.75 13 6.787 24.25 13 24.25" opacity=".5" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"></path><g stroke="#A31A2C" stroke-width="1.5" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"><path d="M13.135 16.173a.202.202 0 0 1 0-.404M13.135 16.173a.202.202 0 0 0 0-.404M13.135 14.154v-4.04"></path><path stroke-linecap="round" stroke-linejoin="round" d="M14.007 6.62a.98.98 0 0 0-.872-.543.98.98 0 0 0-.873.544L7.16 17.012a.82.82 0 0 0 .735 1.18h10.477a.82.82 0 0 0 .695-.386.82.82 0 0 0 .04-.794z"></path></g></g>', 1)
  ])]);
}
const Re = { render: v }, u = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 26",
  style: { "container-type": "size", "aspect-ratio": "40/26", "--icon-vw": "40px", "--icon-vh": "26px" }
};
function k(n, t) {
  return e(), r("svg", u, [...t[0] || (t[0] = [
    s('<defs><rect id="amex_svg__a" width="40" height="26" x="0" y="0" rx="4"></rect></defs><g fill="none" fill-rule="evenodd"><rect width="39" height="25" x=".5" y=".5" fill="#006FCF" stroke="#424446" stroke-opacity=".25" rx="4" data-icon-stroke="" style="--icon-sw:1px;stroke-width:calc(1px*max(40px/100cqw,26px/100cqh));"></rect><g fill="#FFF"><path d="m35.745 17.213 3.413 3.615v-1.522l-1.96-2.113 1.96-2.093v-1.54z"></path><path d="m22.206 21.978 10.51.022 1.651-1.841 1.662 1.834h3.129v-1.06h-2.61l-2.168-2.379-2.146 2.38h-8.896v-7.432h8.969l2.131 2.355 2.137-2.355h2.583v-1.033l-16.952-.016z"></path><path d="M25.379 18.06v1.14h4.26v1.7l3.456-3.687-3.455-3.678v1.679h-4.261v1.162h4.16v1.683zM35.306 4l-.873 2.442L33.563 4h-5.045v3.259L27.083 4h-4.086L18.8 13.524h20.358V12.46l-1.97.017v-5.1l-1.858 5.083h-1.797l-1.897-5.1v5.1h-1.97l.001.001H27.35l-.621-1.487h-3.371l-.622 1.487h-2.262l3.298-7.425h2.612l3.253 7.355V5.033l3.18.011L34.45 9.61l1.647-4.576h3.06V4z"></path><path d="m26.031 9.307-.988-2.364-.99 2.364z"></path></g><g stroke-linejoin="square"><rect width="39" height="25" x=".5" y=".5" stroke="#FFF" rx="4" data-icon-stroke="" style="--icon-sw:1px;stroke-width:calc(1px*max(40px/100cqw,26px/100cqh));"></rect><rect width="39" height="25" x=".5" y=".5" stroke="#424446" stroke-opacity=".25" rx="4" data-icon-stroke="" style="--icon-sw:1px;stroke-width:calc(1px*max(40px/100cqw,26px/100cqh));"></rect></g></g>', 2)
  ])]);
}
const We = { render: k }, M = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 26 26"
};
function f(n, t) {
  return e(), r("svg", M, [...t[0] || (t[0] = [
    s('<defs><path id="apple_svg__a" d="M0 0h20v18.653H0z"></path><path id="apple_svg__c" d="M0 0h4.967v5.677H0z"></path></defs><g fill="none" fill-rule="evenodd"><g transform="translate(3 5.93)"><mask id="apple_svg__b" fill="#fff"><use xlink:href="#apple_svg__a"></use></mask><path fill="currentColor" d="M16.705 7.143c-.029-3.105 2.542-4.616 2.66-4.687C17.909.333 15.652.043 14.859.02c-1.895-.199-3.733 1.134-4.7 1.134-.984 0-2.471-1.114-4.073-1.08-2.062.03-3.991 1.225-5.05 3.078-2.182 3.78-.554 9.336 1.537 12.392 1.047 1.495 2.27 3.167 3.87 3.107 1.566-.065 2.15-.998 4.04-.998 1.873 0 2.422.998 4.054.96 1.68-.027 2.74-1.502 3.749-3.012 1.21-1.716 1.695-3.405 1.714-3.492-.039-.013-3.263-1.242-3.295-4.966" mask="url(#apple_svg__b)"></path></g><g transform="translate(12.938)"><mask id="apple_svg__d" fill="#fff"><use xlink:href="#apple_svg__c"></use></mask><path fill="currentColor" d="M3.683 3.94C4.524 2.888 5.1 1.455 4.94 0 3.722.054 2.197.843 1.32 1.874.542 2.78-.15 4.269.028 5.668c1.369.102 2.774-.69 3.654-1.727" mask="url(#apple_svg__d)"></path></g></g>', 2)
  ])]);
}
const Ue = { render: f }, g = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function z(n, t) {
  return e(), r("svg", g, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M3.599 18.125a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 0 0-5.25 0M10.451 24.5a4.474 4.474 0 0 0-8.449 0M10.251 11v2.25l-3-2.25H3.5A1.5 1.5 0 0 1 2 9.5v-6A1.5 1.5 0 0 1 3.5 2h8.251" }),
      o("path", { d: "M5 6.5 6.5 8l3.75-3M17.651 18.125a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 0 0-5.25 0M16.051 24.5a4.474 4.474 0 0 1 8.449 0M14.751 13.25h.75v2.25l3-2.25h4.5a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0-1.5-1.5h-8.25a1.5 1.5 0 0 0-1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5M20.75 10.25l-3.75-3M17 10.25l3.75-3" })
    ], -1)
  ])]);
}
const Ne = { render: z }, _ = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function m(n, t) {
  return e(), r("svg", _, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M3.571 3H22.43C23.296 3 24 3.704 24 4.571v17.286c0 .868-.704 1.572-1.571 1.572H3.57A1.57 1.57 0 0 1 2 21.857V4.571C2 3.704 2.704 3 3.571 3M2 7.714h22" })
    ], -1)
  ])]);
}
const Te = { render: m }, y = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function C(n, t) {
  return e(), r("svg", y, [...t[0] || (t[0] = [
    o("g", { fill: "currentColor" }, [
      o("path", {
        "fill-rule": "evenodd",
        d: "M23.5 10.22v11.793c0 1.067-.744 1.987-1.75 1.987H4.25c-1.006 0-1.75-.92-1.75-1.987V10.221zm-7.293 2.872H9.792a.75.75 0 1 0 0 1.5h6.415a.75.75 0 1 0 0-1.5"
      }),
      o("path", { d: "M25 3.871v2.803c0 1.015-.763 1.871-1.75 1.871H2.75C1.763 8.545 1 7.689 1 6.674V3.871C1 2.856 1.763 2 2.75 2h20.5c.987 0 1.75.856 1.75 1.871" })
    ], -1)
  ])]);
}
const Qe = { render: C }, q = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function $(n, t) {
  return e(), r("svg", q, [...t[0] || (t[0] = [
    o("defs", null, [
      o("path", {
        id: "archived_svg__a",
        d: "M21.75 20.013c0 .683-.448 1.237-1 1.237H3.25c-.552 0-1-.554-1-1.237V5.795h19.5Zm1.5-18.142v2.803c0 .619-.448 1.121-1 1.121H1.75c-.552 0-1-.502-1-1.121V1.871c0-.619.448-1.121 1-1.121h20.5c.552 0 1 .502 1 1.121"
      })
    ], -1),
    o("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", {
        "stroke-linecap": "square",
        d: "M22.75 7.795v14.218c0 .683-.448 1.237-1 1.237H4.25c-.552 0-1-.554-1-1.237V7.795M23.25 2.75H2.75c-.552 0-1 .502-1 1.121v2.803c0 .619.448 1.121 1 1.121h20.5c.552 0 1-.502 1-1.121V3.871c0-.619-.448-1.121-1-1.121Z"
      }),
      o("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M9.792 11.842h6.415"
      })
    ], -1)
  ])]);
}
const Je = { render: $ }, B = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function I(n, t) {
  return e(), r("svg", B, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M24.46 13.5h-23" }),
      o("path", {
        "stroke-linecap": "square",
        "stroke-linejoin": "round",
        d: "M9.422 5.539 1.462 13.5l7.96 7.96"
      })
    ], -1)
  ])]);
}
const Ke = { render: I }, V = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function H(n, t) {
  return e(), r("svg", V, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M21.922 12.922 3.46 12.96" }),
      o("path", {
        "stroke-linecap": "square",
        "stroke-linejoin": "round",
        d: "m11.422 5-7.96 7.96 7.96 7.962"
      })
    ], -1)
  ])]);
}
const Xe = { render: H }, A = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function j(n, t) {
  return e(), r("svg", A, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "m4 13 18.46-.039" }),
      o("path", {
        "stroke-linecap": "square",
        "stroke-linejoin": "round",
        d: "m14.5 20.922 7.96-7.961L14.5 5"
      })
    ], -1)
  ])]);
}
const Ye = { render: j }, L = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function F(n, t) {
  return e(), r("svg", L, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "m19.5 16.5-6.5 6-6.5-6M6.5 9.5l6.5-6 6.5 6" })
    ], -1)
  ])]);
}
const tr = { render: F }, b = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function S(n, t) {
  return e(), r("svg", b, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "m17 6.5 6.5 6.5-6.54 6.5" }),
      o("path", {
        "stroke-linecap": "round",
        d: "M7.018 2.062V5.5a7.5 7.5 0 0 0 7.5 7.5H23.5"
      })
    ], -1)
  ])]);
}
const or = { render: S }, D = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Z(n, t) {
  return e(), r("svg", D, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M12.961 25V2" }),
      o("path", {
        "stroke-linecap": "square",
        "stroke-linejoin": "round",
        d: "m20.922 9.961-7.961-7.96L5 9.96"
      })
    ], -1)
  ])]);
}
const er = { render: Z }, E = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function G(n, t) {
  return e(), r("svg", E, [...t[0] || (t[0] = [
    o("path", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M24.5 10.957 13.523 21.935a6.75 6.75 0 0 1-9.546-9.546l9.016-9.015a4.5 4.5 0 1 1 6.363 6.363l-9.015 9.02a2.25 2.25 0 0 1-3.182-3.181l9.016-9.02",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, null, -1)
  ])]);
}
const rr = { render: G }, O = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function P(n, t) {
  return e(), r("svg", O, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "m19.05 11.803-4.7-4.7 2.524-2.526a1.97 1.97 0 0 1 2.783-.001h.001l1.918 1.919a1.97 1.97 0 0 1 0 2.783z" }),
      o("path", { d: "m19.05 11.803-4.7-4.7L8.276 9.65a2.22 2.22 0 0 0-1.522 1.527L4.021 21.446a.554.554 0 0 0 .685.685l10.273-2.734a2.22 2.22 0 0 0 1.523-1.52zM4.162 21.99l7.466-7.467" })
    ], -1)
  ])]);
}
const nr = { render: P }, R = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function W(n, t) {
  return e(), r("svg", R, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M2.5 24h21M2.5 21h21M4 10.5V18M7 10.501V18M11.5 10.501V18M14.5 10.501V18M19 10.501V18M22 10.501V18M23.5 7.5h-21l9.689-5.761a1.5 1.5 0 0 1 1.622 0z" })
    ], -1)
  ])]);
}
const sr = { render: W }, U = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function N(n, t) {
  return e(), r("svg", U, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M7.25 12h-3a.75.75 0 0 0-.75.75v9.75H8v-9.75a.75.75 0 0 0-.75-.75M14.75 3h-3a.75.75 0 0 0-.75.75V22.5h4.5V3.75a.75.75 0 0 0-.75-.75M22.25 7.5h-3a.75.75 0 0 0-.75.75V22.5H23V8.25a.75.75 0 0 0-.75-.75" })
    ], -1)
  ])]);
}
const lr = { render: N }, T = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Q(n, t) {
  return e(), r("svg", T, [...t[0] || (t[0] = [
    s('<defs><path id="bass_svg__a" d="M21.23 2.312v17.376c0 .85-.691 1.541-1.542 1.541H2.312c-.85 0-1.541-.69-1.541-1.541V2.312c0-.85.69-1.541 1.541-1.541h17.376c.85 0 1.541.69 1.541 1.541"></path></defs><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"><path d="M21.688 23.23H4.312c-.85 0-1.541-.691-1.541-1.542V4.312c0-.85.69-1.541 1.541-1.541h17.376c.85 0 1.541.69 1.541 1.541v17.376c0 .85-.69 1.541-1.541 1.541M2.771 6.909h20.458"></path><path d="M19.058 14.965a6.058 6.058 0 1 1-12.116 0 6.058 6.058 0 0 1 12.116 0M20.614 4.788a.396.396 0 1 1-.796 0 .396.396 0 0 1 .796 0M17.752 4.788a.396.396 0 1 1-.796 0 .396.396 0 0 1 .796 0"></path><path d="M14.33 14.965a1.33 1.33 0 1 1-2.659 0 1.33 1.33 0 0 1 2.659 0"></path></g>', 2)
  ])]);
}
const ir = { render: Q }, J = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function K(n, t) {
  return e(), r("svg", J, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", {
        "stroke-linecap": "round",
        d: "M20.75 4.077a3 3 0 1 1 0 6 3 3 0 0 1 0-6M11 23a2.087 2.087 0 0 0 4.005 0M13 4.25V2"
      }),
      o("path", {
        "stroke-linecap": "square",
        d: "M20.523 13.211C20.712 18.967 22 20 22 20H4s1.5-1.916 1.5-8.25a7.507 7.507 0 0 1 9.724-7.165"
      })
    ], -1)
  ])]);
}
const cr = { render: K }, X = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 27 26",
  style: { "container-type": "size", "aspect-ratio": "27/26", "--icon-vw": "27px", "--icon-vh": "26px" }
};
function Y(n, t) {
  return e(), r("svg", X, [...t[0] || (t[0] = [
    s('<g fill="none" fill-rule="evenodd"><g stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(27px/100cqw,26px/100cqh));"><path stroke-linecap="round" d="M20.75 4.077a3 3 0 1 1 0 6 3 3 0 0 1 0-6M11 23a2.087 2.087 0 0 0 4.005 0M13 4.25V2"></path><path stroke-linecap="square" d="M20.523 13.211C20.712 18.967 22 20 22 20H4s1.5-1.916 1.5-8.25a7.507 7.507 0 0 1 9.724-7.165"></path></g><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(27px/100cqw,26px/100cqh));"><path d="M11 23a2.087 2.087 0 0 0 4.005 0M13 4.25V2M13 4.25a7.5 7.5 0 0 1 7.5 7.5C20.5 18.796 22 20 22 20H4s1.5-1.916 1.5-8.25a7.5 7.5 0 0 1 7.5-7.5"></path></g><g transform="translate(12.858 1)"><path stroke="#FFF" stroke-width="2" d="M3.028 1.77a1.2 1.2 0 0 1 .416.133c.133.068.27.161.429.285.25.195.574.482.966.852a64 64 0 0 1 2.612 2.65 56 56 0 0 1 2.464 2.785q.519.638.778 1.048c.116.184.2.344.253.507.165.498.107 1.05-.539 1.354l-.466.197a6.502 6.502 0 0 1-7.948-9.3c.235-.413.65-.56 1.035-.512Z" data-icon-stroke="" style="--icon-sw:2px;stroke-width:calc(2px*max(27px/100cqw,26px/100cqh));"></path><circle cx="7.641" cy="5.5" r="5.5" fill="#DC3C3F"></circle></g></g>', 1)
  ])]);
}
const ar = { render: Y }, t1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function o1(n, t) {
  return e(), r("svg", t1, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M11 23a2.087 2.087 0 0 0 4.005 0zM13 4.25V2" }),
      o("path", {
        fill: "currentColor",
        d: "M13 4.25a7.5 7.5 0 0 1 7.5 7.5C20.5 18.796 22 20 22 20H4s1.5-1.916 1.5-8.25a7.5 7.5 0 0 1 7.5-7.5"
      })
    ], -1)
  ])]);
}
const hr = { render: o1 }, e1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function r1(n, t) {
  return e(), r("svg", e1, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M11 23a2.087 2.087 0 0 0 4.005 0M13 4.25V2M13 4.25a7.5 7.5 0 0 1 7.5 7.5C20.5 18.796 22 20 22 20H4s1.5-1.916 1.5-8.25a7.5 7.5 0 0 1 7.5-7.5" })
    ], -1)
  ])]);
}
const pr = { render: r1 }, n1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function s1(n, t) {
  return e(), r("svg", n1, [...t[0] || (t[0] = [
    o("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M19.32 23.674 13 19.25l-6.32 4.424a.75.75 0 0 1-1.18-.614V3.5A1.5 1.5 0 0 1 7 2h12a1.5 1.5 0 0 1 1.5 1.5v19.56a.75.75 0 0 1-1.18.614",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, null, -1)
  ])]);
}
const dr = { render: s1 }, l1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function i1(n, t) {
  return e(), r("svg", l1, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M3.5 5H23a1.5 1.5 0 0 1 1.5 1.5V23a1.5 1.5 0 0 1-1.5 1.5H3.5A1.5 1.5 0 0 1 2 23V6.5A1.5 1.5 0 0 1 3.5 5M2 11h22.5M8 7.25V2M18.5 7.25V2" })
    ], -1)
  ])]);
}
const xr = { render: i1 }, c1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function a1(n, t) {
  return e(), r("svg", c1, [...t[0] || (t[0] = [
    o("defs", null, [
      o("path", {
        id: "camera_svg__a",
        d: "M13.982.749a1.54 1.54 0 0 1 1.296.698l1.456 2.256c.28.435.77.7 1.296.7h3.672c.846 0 1.532.67 1.532 1.496v11.82c-.003 1.398-1.161 2.53-2.593 2.533H3.359c-1.432-.003-2.59-1.135-2.593-2.533V5.9c0-.826.686-1.497 1.532-1.497H5.97a1.54 1.54 0 0 0 1.296-.699l1.456-2.256a1.54 1.54 0 0 1 1.296-.698z"
      })
    ], -1),
    o("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M3.298 6.402H6.97a1.54 1.54 0 0 0 1.296-.699l1.456-2.256a1.54 1.54 0 0 1 1.296-.698h3.964a1.54 1.54 0 0 1 1.296.698l1.456 2.256c.28.435.77.7 1.296.7h3.672c.846 0 1.532.67 1.532 1.496v11.82c-.003 1.398-1.161 2.53-2.593 2.533H4.359c-1.432-.003-2.59-1.135-2.593-2.533V7.9c0-.826.686-1.497 1.532-1.497" }),
      o("path", { d: "M9.255 13.718c0 2.02 1.676 3.657 3.745 3.657s3.744-1.637 3.744-3.657S15.068 10.06 13 10.06s-3.745 1.637-3.745 3.658" })
    ], -1)
  ])]);
}
const wr = { render: a1 }, h1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function p1(n, t) {
  return e(), r("svg", h1, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "1.5",
      transform: "translate(2 2)",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("rect", {
        width: "22",
        height: "22",
        rx: "5"
      }),
      o("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "m5 12.395 2.45 3.477a1.05 1.05 0 0 0 1.707.051L17 6"
      })
    ], -1)
  ])]);
}
const vr = { render: p1 }, d1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function x1(n, t) {
  return e(), r("svg", d1, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-width": "1.5",
      transform: "translate(2 2)",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("rect", {
        width: "22",
        height: "22",
        fill: "currentColor",
        stroke: "currentColor",
        rx: "5"
      }),
      o("path", {
        stroke: "#FFF",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "m5 12.395 2.45 3.477a1.05 1.05 0 0 0 1.707.051L17 6"
      })
    ], -1)
  ])]);
}
const ur = { render: x1 }, w1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function v1(n, t) {
  return e(), r("svg", w1, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M13 24.25c6.213 0 11.25-5.037 11.25-11.25S19.213 1.75 13 1.75 1.75 6.787 1.75 13 6.787 24.25 13 24.25" }),
      o("path", { d: "m7 14.395 2.45 3.477a1.05 1.05 0 0 0 1.707.051L19 8" })
    ], -1)
  ])]);
}
const kr = { render: v1 }, u1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 12",
  style: { "container-type": "size", "aspect-ratio": "12/12", "--icon-vw": "12px", "--icon-vh": "12px" }
};
function k1(n, t) {
  return e(), r("svg", u1, [...t[0] || (t[0] = [
    o("defs", null, [
      o("path", {
        id: "checked-small-solid_svg__a",
        d: "M6 .808a5.192 5.192 0 1 1 0 10.385A5.192 5.192 0 0 1 6 .808"
      })
    ], -1),
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      o("path", {
        fill: "currentColor",
        stroke: "currentColor",
        "stroke-width": "1.5",
        d: "M6 11.192A5.192 5.192 0 1 0 6 .807a5.192 5.192 0 0 0 0 10.385",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(12px/100cqw,12px/100cqh))" }
      }),
      o("path", {
        stroke: "#FFF",
        d: "m3.23 6.644 1.132 1.605a.484.484 0 0 0 .787.023l3.62-4.58",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1px", "stroke-width": "calc(1px*max(12px/100cqw,12px/100cqh))" }
      })
    ], -1)
  ])]);
}
const Mr = { render: k1 }, M1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function f1(n, t) {
  return e(), r("svg", M1, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", {
        fill: "#B8E7EA",
        stroke: "#B8E7EA",
        d: "M13 24.25c6.213 0 11.25-5.037 11.25-11.25S19.213 1.75 13 1.75 1.75 6.787 1.75 13 6.787 24.25 13 24.25"
      }),
      o("path", {
        stroke: "#003C4D",
        d: "m7 14.395 2.45 3.477a1.05 1.05 0 0 0 1.707.051L19 8"
      })
    ], -1)
  ])]);
}
const fr = { render: f1 }, g1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function z1(n, t) {
  return e(), r("svg", g1, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M3.25 1.75h19.5a1.5 1.5 0 0 1 1.5 1.5v19.5a1.5 1.5 0 0 1-1.5 1.5H3.25a1.5 1.5 0 0 1-1.5-1.5V3.25a1.5 1.5 0 0 1 1.5-1.5" }),
      o("path", { d: "m13 5.5-4.5 6-3-3M15.25 9.25h4.5M13 14.5l-4.5 6-3-3M15.25 18.25h4.5" })
    ], -1)
  ])]);
}
const gr = { render: z1 }, _1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function m1(n, t) {
  return e(), r("svg", _1, [...t[0] || (t[0] = [
    o("path", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m3 14.658 4.083 5.795a1.75 1.75 0 0 0 2.845.085L23 4",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, null, -1)
  ])]);
}
const zr = { render: m1 }, y1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function C1(n, t) {
  return e(), r("svg", y1, [...t[0] || (t[0] = [
    o("path", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m5 10 7.96 7.961 7.962-7.96",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, null, -1)
  ])]);
}
const _r = { render: C1 }, q1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function $1(n, t) {
  return e(), r("svg", q1, [...t[0] || (t[0] = [
    o("path", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m15.941 5.02-7.96 7.96 7.96 7.961",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, null, -1)
  ])]);
}
const mr = { render: $1 }, B1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function I1(n, t) {
  return e(), r("svg", B1, [...t[0] || (t[0] = [
    o("path", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m9.98 20.941 7.961-7.96-7.96-7.961",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, null, -1)
  ])]);
}
const yr = { render: I1 }, V1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function H1(n, t) {
  return e(), r("svg", V1, [...t[0] || (t[0] = [
    o("path", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M20.922 15.96 12.96 8 5 15.96",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, null, -1)
  ])]);
}
const Cr = { render: H1 }, A1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 26 26"
};
function j1(n, t) {
  return e(), r("svg", A1, [...t[0] || (t[0] = [
    s('<defs><path id="chrome_svg__a" d="M12.366.006A11.99 11.99 0 0 1 22.389 6H12.168l.057.002h10.163l.192.345a12 12 0 0 1 1.417 5.657c0 6.624-5.372 11.994-11.995 11.993l-.395-.006a12 12 0 0 1-5.608-1.602C.262 19.077-1.703 11.74 1.611 6.004l5.194 8.997.033.054a6 6 0 0 1-.133-.236L1.61 6.003a12 12 0 0 1 4.394-4.395A11.94 11.94 0 0 1 11.938 0h.102Z"></path><path id="chrome_svg__b" d="M10.328 0C8.31.008 6.267.527 4.394 1.608A12 12 0 0 0 0 6.002L5.195 15l.005-.001a5.99 5.99 0 0 1 2.177-8.19 6 6 0 0 1 3.013-.808h10.389A11.99 11.99 0 0 0 10.429 0z"></path><path id="chrome_svg__e" d="M.001 0 0 .004a5.99 5.99 0 0 1 6.003 5.98A6 6 0 0 1 5.197 9L.002 17.996C6.627 17.996 12 12.626 12 6.002c0-2.107-.554-4.177-1.609-6.002z"></path><path id="chrome_svg__h" d="M5.998 16.386a12 12 0 0 0 6.003 1.608l5.194-8.997-.003-.003a5.99 5.99 0 0 1-8.18 2.208 6 6 0 0 1-2.207-2.205L1.61 0C-1.703 5.737.262 13.073 5.998 16.386"></path><linearGradient id="chrome_svg__c" x1=".001%" x2="100%" y1="50%" y2="50%"><stop offset="0%" stop-color="#D82F24"></stop><stop offset="100%" stop-color="#E94234"></stop></linearGradient><linearGradient id="chrome_svg__f" x1="21.709%" x2="60.203%" y1="99.111%" y2="-.884%"><stop offset="0%" stop-color="#FBC834"></stop><stop offset="100%" stop-color="#FBBC04"></stop></linearGradient><linearGradient id="chrome_svg__i" x1="74.958%" x2="19.785%" y1="95.839%" y2="-4.165%"><stop offset="0%" stop-color="#1D8E3D"></stop><stop offset="100%" stop-color="#34A852"></stop></linearGradient></defs><g fill="none" fill-rule="evenodd"><path fill="#FFF" d="M13 6.998a6 6 0 1 1 0 11.999 6 6 0 0 1 0-11.999"></path><g transform="translate(2.61 1)"><mask id="chrome_svg__d" fill="#fff"><use xlink:href="#chrome_svg__b"></use></mask><path fill="url(#chrome_svg__c)" d="M10.328 0C8.31.008 6.267.527 4.394 1.608A12 12 0 0 0 0 6.002L5.195 15l.005-.001a5.99 5.99 0 0 1 2.177-8.19 6 6 0 0 1 3.013-.808h10.389A11.99 11.99 0 0 0 10.429 0z" mask="url(#chrome_svg__d)"></path></g><path fill="#1A73E8" d="M13 8.25a4.749 4.749 0 1 1 0 9.499 4.749 4.749 0 0 1 0-9.498"></path><g transform="translate(12.998 7.003)"><mask id="chrome_svg__g" fill="#fff"><use xlink:href="#chrome_svg__e"></use></mask><path fill="url(#chrome_svg__f)" d="M.001 0 0 .004a5.99 5.99 0 0 1 6.003 5.98A6 6 0 0 1 5.197 9L.002 17.996C6.627 17.996 12 12.626 12 6.002c0-2.107-.554-4.177-1.609-6.002z" mask="url(#chrome_svg__g)"></path></g><g transform="translate(1 7.004)"><mask id="chrome_svg__j" fill="#fff"><use xlink:href="#chrome_svg__h"></use></mask><path fill="url(#chrome_svg__i)" d="M5.998 16.386a12 12 0 0 0 6.003 1.608l5.194-8.997-.003-.003a5.99 5.99 0 0 1-8.18 2.208 6 6 0 0 1-2.207-2.205L1.61 0C-1.703 5.737.262 13.073 5.998 16.386" mask="url(#chrome_svg__j)"></path></g></g>', 2)
  ])]);
}
const qr = { render: j1 }, L1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function F1(n, t) {
  return e(), r("svg", L1, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M2 13c0 6.075 4.925 11 11 11s11-4.925 11-11S19.075 2 13 2 2 6.925 2 13M13 13V9.071M13 13l4.91 4.911" })
    ], -1)
  ])]);
}
const $r = { render: F1 }, b1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function S1(n, t) {
  return e(), r("svg", b1, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M4.32 21.68 21.68 4.32M4.32 4.32l17.36 17.36" })
    ], -1)
  ])]);
}
const Br = { render: S1 }, D1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Z1(n, t) {
  return e(), r("svg", D1, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "m10.895 17.347 4.21-9.403M19.707 7.945l4.487 4.7-4.487 4.702M6.293 17.347l-4.487-4.7 4.487-4.703" })
    ], -1)
  ])]);
}
const Ir = { render: Z1 }, E1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function G1(n, t) {
  return e(), r("svg", E1, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M6.999 13.334h17.335" }),
      o("path", {
        "stroke-linecap": "square",
        d: "m18.333 19.334 6-6-6-6M2.334 24.334v-22"
      })
    ], -1)
  ])]);
}
const Vr = { render: G1 }, O1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function P1(n, t) {
  return e(), r("svg", O1, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M17 24.5H9.5l.75-4.5h6zM7.25 24.5h12M2 16h22.5" }),
      o("path", { d: "M5 2h16.5a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3" })
    ], -1)
  ])]);
}
const Hr = { render: P1 }, R1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function W1(n, t) {
  return e(), r("svg", R1, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M9 8a2.366 2.366 0 1 1 .001 4.731 2.366 2.366 0 0 1 0-4.731M4.945 17.464a4.056 4.056 0 0 1 8.111 0zM15.501 8.75H20M15.501 11.75H21.5" }),
      o("path", { d: "M22.11 22.5H3.952A1.95 1.95 0 0 1 2 20.549V6.002c0-1.077.874-1.95 1.952-1.95H22.11c1.078 0 1.95.873 1.95 1.95V20.55a1.95 1.95 0 0 1-1.95 1.951" })
    ], -1)
  ])]);
}
const Ar = { render: W1 }, U1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function N1(n, t) {
  return e(), r("svg", U1, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M4.625 9.125a4.125 4.125 0 1 0 8.25 0 4.125 4.125 0 0 0-8.25 0M2 21.5a6.75 6.75 0 1 1 13.5 0M15.602 11.375a3.375 3.375 0 1 0 6.75.004v-.004a3.375 3.375 0 1 0-6.75-.004zM17.063 16.318A5.526 5.526 0 0 1 24.5 21.5" })
    ], -1)
  ])]);
}
const jr = { render: N1 }, T1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Q1(n, t) {
  return e(), r("svg", T1, [...t[0] || (t[0] = [
    s('<defs><path id="copy_svg__a" d="M0 0h5v21H0z"></path><path id="copy_svg__c" d="M0 0h23v5H0z"></path></defs><g fill="none" fill-rule="evenodd"><rect width="17" height="17" x="7" y="7" stroke="currentColor" stroke-width="1.5" rx="3" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"></rect><mask id="copy_svg__b" fill="#fff"><use xlink:href="#copy_svg__a" transform="matrix(-1 0 0 1 5 0)"></use></mask><path stroke="currentColor" stroke-width="1.5" d="M5 2h11a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3Z" mask="url(#copy_svg__b)" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"></path><mask id="copy_svg__d" fill="#fff"><use xlink:href="#copy_svg__c" transform="matrix(-1 0 0 1 23 0)"></use></mask><path stroke="currentColor" stroke-width="1.5" d="M5 2h11a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3Z" mask="url(#copy_svg__d)" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"></path></g>', 2)
  ])]);
}
const Lr = { render: Q1 }, J1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function K1(n, t) {
  return e(), r("svg", J1, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "m17.006 11-3.981 5.308a.75.75 0 0 1-1.13.08L9.505 14" }),
      o("path", { d: "M11.986 2.608a1.63 1.63 0 0 1 2.54 0l1.512 1.881c.348.434.893.66 1.446.6l2.4-.26a1.63 1.63 0 0 1 1.8 1.8l-.261 2.4c-.06.552.166 1.097.6 1.445l1.88 1.512a1.63 1.63 0 0 1 0 2.54l-1.886 1.505a1.63 1.63 0 0 0-.6 1.447l.26 2.4a1.63 1.63 0 0 1-1.8 1.8l-2.4-.26a1.63 1.63 0 0 0-1.445.6l-1.506 1.873a1.63 1.63 0 0 1-2.54 0l-1.511-1.88a1.63 1.63 0 0 0-1.447-.6l-2.4.261a1.628 1.628 0 0 1-1.8-1.8l.26-2.4a1.63 1.63 0 0 0-.6-1.447l-1.88-1.51a1.63 1.63 0 0 1 0-2.54l1.88-1.513c.435-.348.66-.893.6-1.446l-.26-2.4a1.63 1.63 0 0 1 1.8-1.8l2.4.261a1.63 1.63 0 0 0 1.447-.6z" })
    ], -1)
  ])]);
}
const Fr = { render: K1 }, X1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Y1(n, t) {
  return e(), r("svg", X1, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M3.571 5H22.43C23.296 5 24 5.551 24 6.23v13.54c0 .679-.704 1.23-1.571 1.23H3.57C2.704 21 2 20.449 2 19.77V6.23C2 5.552 2.704 5 3.571 5M2 9.5h22" })
    ], -1)
  ])]);
}
const br = { render: Y1 }, t0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function o0(n, t) {
  return e(), r("svg", t0, [...t[0] || (t[0] = [
    s('<g fill="none" fill-rule="evenodd"><g stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"><path stroke-linecap="square" d="M10 17.5a7.5 7.5 0 0 0 7.5 7.5 7.5 7.5 0 0 0 7.5-7.5 7.5 7.5 0 0 0-7.5-7.5 7.5 7.5 0 0 0-7.5 7.5Z"></path><path stroke-linecap="round" d="M19.5 15.248a1.5 1.5 0 0 0-3 0v3.75a1.5 1.5 0 0 1-1.5 1.5h4.5M15 17.498h3"></path></g><path fill="#FFF" d="M1 8.5A7.5 7.5 0 0 0 8.5 16 7.5 7.5 0 0 0 16 8.5 7.5 7.5 0 0 0 8.5 1 7.5 7.5 0 0 0 1 8.5"></path><g stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"><path stroke-linecap="round" d="M10 5.502H7.967a1.342 1.342 0 0 0-.5 2.587l2.064.825a1.342 1.342 0 0 1-.5 2.588H7M8.5 5.502v-.75M8.5 12.252v-.75"></path><path stroke-linecap="square" d="M1 8.5A7.5 7.5 0 0 0 8.5 16 7.5 7.5 0 0 0 16 8.5 7.5 7.5 0 0 0 8.5 1 7.5 7.5 0 0 0 1 8.5Z"></path></g></g>', 1)
  ])]);
}
const Sr = { render: o0 }, e0 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 101 26"
};
function r0(n, t) {
  return e(), r("svg", e0, [...t[0] || (t[0] = [
    s('<defs><path id="dacr-AI_svg__a" d="M99 0v22H1V0z"></path><path id="dacr-AI_svg__b" d="M33.752 10.984v5.762c-.755 1.455-2.483 2.393-4.413 2.393-2.888 0-4.755-2.07-4.755-5.274S26.451 8.59 29.34 8.59c1.93 0 3.658.938 4.413 2.393m.032-3.306c-1.18-1.292-2.852-1.948-4.977-1.948-2.207 0-4.025.754-5.402 2.242-1.392 1.504-2.068 3.443-2.068 5.927 0 2.404.696 4.375 2.068 5.858C24.782 21.245 26.6 22 28.807 22c2.125 0 3.796-.656 4.977-1.949v1.577h3.256V6.087h-3.256zm25.55.722.001-2.314h-3.248v15.542h3.247V11.476c.013-.074.05-.12.118-.188 1.967-2.1 4.096-2.672 5.977-2.262V5.894c-2.687-.554-4.605.393-6.094 2.506m-44.06 6.25a6.9 6.9 0 0 1-2.657 2.649c-1.132.638-2.43.961-3.86.961h-4.32V3.387h4.32c1.429 0 2.728.324 3.86.962a6.9 6.9 0 0 1 2.657 2.65c.63 1.119.949 2.406.949 3.825s-.32 2.707-.95 3.825m-.937-13.225C12.685.492 10.807.02 8.757.02H1v21.608h7.758c2.05 0 3.928-.473 5.58-1.404a10.3 10.3 0 0 0 3.906-3.857c.941-1.629 1.418-3.493 1.418-5.543s-.477-3.915-1.418-5.543a10.3 10.3 0 0 0-3.907-3.857M47.09 8.617c1.757 0 3.216.81 3.808 2.12.044.093.158.316.158.316l.078.152.16-.068c.001 0 .154-.066.261-.104l1.867-.722c.117-.053.33-.136.33-.137l.181-.07-.223-.472c-1.047-2.41-3.546-3.907-6.522-3.907-2.313 0-4.19.757-5.577 2.249-1.393 1.498-2.1 3.484-2.1 5.902 0 2.396.707 4.37 2.102 5.87 1.44 1.512 3.263 2.247 5.575 2.247 3.037 0 5.475-1.461 6.519-3.901.05-.106.136-.315.136-.315l.068-.164-.167-.069s-.21-.086-.332-.14l-2.302-.892-.071.16s-.093.209-.142.311c-.663 1.426-1.908 2.118-3.807 2.118-2.677 0-4.475-2.1-4.475-5.225 0-3.195 1.756-5.26 4.475-5.26M79.46.06 71.3 21.6h3.81l1.83-4.92h9.3l1.86 4.92h3.87L83.81.06zm2.1 4.26 3.42 9H78.2zM98.15.06h-3.84V21.6h3.84z"></path><linearGradient id="dacr-AI_svg__c" x1="6.107%" x2="94.545%" y1="50%" y2="50%"><stop offset=".011%" stop-color="#F5B958"></stop><stop offset="50.647%" stop-color="#F84600"></stop><stop offset="100%" stop-color="#CE489A"></stop></linearGradient></defs><g fill="none" transform="translate(1 2)"><mask id="dacr-AI_svg__d" fill="#fff"><use xlink:href="#dacr-AI_svg__b"></use></mask><path fill="url(#dacr-AI_svg__c)" fill-rule="evenodd" d="M1 0h98v22H1z" mask="url(#dacr-AI_svg__d)"></path></g>', 2)
  ])]);
}
const Dr = { render: r0 }, n0 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 88 26"
};
function s0(n, t) {
  return e(), r("svg", n0, [...t[0] || (t[0] = [
    s('<defs><path id="dacr_svg__a" d="m24 24-11.924-.001-.074.001H0V0h24ZM58.478 9.22V7.813h2.819v13.736h-2.819v-1.394c-1.021 1.143-2.468 1.723-4.308 1.723-1.91 0-3.483-.667-4.675-1.982-1.188-1.311-1.79-3.053-1.79-5.178 0-2.196.585-3.91 1.79-5.239 1.192-1.315 2.765-1.981 4.675-1.981 1.84 0 3.287.58 4.308 1.722m17.247 1.727.194.417-.156.062s-.185.074-.287.12l-1.615.639a4 4 0 0 0-.227.092l-.138.06-.068-.135s-.098-.196-.137-.28c-.512-1.156-1.775-1.873-3.296-1.873-2.353 0-3.873 1.825-3.873 4.648 0 2.763 1.556 4.619 3.873 4.619 1.644 0 2.722-.612 3.296-1.872.042-.09.122-.275.123-.276l.061-.14 1.993.787c.105.048.286.125.287.125l.144.06-.058.146s-.074.184-.118.277c-.904 2.157-3.014 3.449-5.643 3.449-2 0-3.58-.65-4.826-1.986-1.207-1.326-1.82-3.071-1.82-5.189 0-2.137.613-3.892 1.82-5.216 1.2-1.319 2.824-1.987 4.826-1.987 2.577 0 4.74 1.323 5.645 3.453m-34.08-7.255a9 9 0 0 1 3.382 3.41c.815 1.438 1.228 3.086 1.228 4.898s-.413 3.46-1.228 4.899a9 9 0 0 1-3.382 3.409c-1.43.823-3.054 1.241-4.83 1.241h-6.714V2.451h6.715c1.774 0 3.4.418 4.83 1.241M85.871 21.55h-8.087V7.505h8.087Zm-35.356-6.861c0 2.832 1.616 4.661 4.116 4.661 1.67 0 3.166-.83 3.82-2.115v-5.093l-.132-.235c-.71-1.151-2.122-1.88-3.688-1.88-2.5 0-4.116 1.83-4.116 4.662m-17.438-9.26v13.145h3.739c1.237 0 2.361-.286 3.341-.85a6 6 0 0 0 2.3-2.342c.545-.989.821-2.126.821-3.381s-.276-2.392-.821-3.381a6 6 0 0 0-2.3-2.342c-.98-.564-2.104-.85-3.341-.85Z"></path><path id="dacr_svg__b" d="M0 0h8.086v14.044H0z"></path></defs><g fill="none" fill-rule="evenodd"><path fill="currentColor" d="M59.45 13.141v5.093c-.654 1.286-2.15 2.115-3.82 2.115-2.5 0-4.116-1.83-4.116-4.661 0-2.832 1.615-4.662 4.116-4.662 1.67 0 3.166.83 3.82 2.115m.027-2.921c-1.022-1.143-2.469-1.722-4.308-1.722-1.91 0-3.484.666-4.676 1.981-1.205 1.33-1.79 3.043-1.79 5.239 0 2.125.602 3.867 1.79 5.178 1.192 1.315 2.765 1.982 4.676 1.982 1.84 0 3.286-.58 4.308-1.723v1.394h2.818V8.813h-2.818z"></path><g transform="translate(78.783 8.505)"><mask id="dacr_svg__c" fill="#fff"><use xlink:href="#dacr_svg__b"></use></mask><path fill="currentColor" d="M2.811 2.353V.307H0v13.737h2.81V5.07c.011-.066.044-.106.103-.166 1.702-1.857 3.545-2.362 5.173-2V.138C5.76-.353 4.1.484 2.811 2.353" mask="url(#dacr_svg__c)"></path></g><path fill="currentColor" d="M43.455 16.381a6 6 0 0 1-2.3 2.342c-.98.564-2.103.85-3.34.85h-3.74V6.427h3.74c1.236 0 2.36.286 3.34.85a6 6 0 0 1 2.3 2.342c.546.99.822 2.127.822 3.381s-.276 2.392-.822 3.381m-.811-11.689c-1.43-.823-3.055-1.24-4.83-1.24H31.1v19.097h6.715c1.776 0 3.4-.418 4.83-1.241a9 9 0 0 0 3.382-3.409c.814-1.44 1.227-3.087 1.227-4.899s-.413-3.46-1.227-4.899a9 9 0 0 0-3.382-3.409M70.994 11.05c1.521 0 2.783.716 3.296 1.873.039.083.137.28.137.28l.067.134.139-.06c.001 0 .133-.059.226-.092l1.616-.639c.101-.046.286-.12.286-.12l.156-.062-.193-.417c-.906-2.13-3.069-3.453-5.646-3.453-2.002 0-3.626.668-4.826 1.987-1.207 1.324-1.819 3.08-1.819 5.216 0 2.118.612 3.863 1.82 5.189 1.246 1.336 2.825 1.986 4.825 1.986 2.63 0 4.74-1.292 5.643-3.449.044-.093.118-.277.118-.277l.059-.146-.145-.06s-.182-.077-.286-.125l-1.993-.788-.062.141s-.08.185-.123.276c-.573 1.26-1.651 1.872-3.295 1.872-2.317 0-3.874-1.856-3.874-4.619 0-2.823 1.52-4.648 3.874-4.648M15.921 13.038a2.957 2.957 0 0 1-2.953 2.954 2.957 2.957 0 0 1-2.954-2.954 2.957 2.957 0 0 1 2.954-2.953h2.953zm7.7-5.62h-3.146A9.3 9.3 0 0 1 22.332 13c0 5.147-4.187 9.334-9.333 9.334-5.147 0-9.335-4.187-9.335-9.334S7.852 3.666 13 3.666a9.3 9.3 0 0 1 2.922.471V7.42h-2.953a5.626 5.626 0 0 0-5.62 5.62 5.626 5.626 0 0 0 5.62 5.62 5.626 5.626 0 0 0 5.62-5.62V2.381A11.94 11.94 0 0 0 12.998 1c-6.627 0-12 5.373-12 12s5.373 12 12 12c6.628 0 12-5.373 12-12 0-2.016-.499-3.914-1.377-5.581"></path></g>', 2)
  ])]);
}
const Zr = { render: s0 }, l0 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 26 22"
};
function i0(n, t) {
  return e(), r("svg", l0, [...t[0] || (t[0] = [
    s('<defs><path id="dacr-license-icon_svg__a" d="M0 0h16.111v18H0z"></path></defs><g fill="none" fill-rule="evenodd"><path fill="currentColor" d="M22.332 13.244a2.224 2.224 0 0 1-2.228-2.215V3.036h-2.012v7.993c0 2.324 1.903 4.215 4.24 4.215H25v-2z"></path><g transform="translate(2 2)"><mask id="dacr-license-icon_svg__b" fill="#fff"><use xlink:href="#dacr-license-icon_svg__a"></use></mask><path fill="currentColor" d="M11.258 9.029c0 1.221-1 2.215-2.228 2.215A2.224 2.224 0 0 1 6.802 9.03c0-1.222 1-2.215 2.228-2.215h2.228zm3.422 4.176a7.05 7.05 0 0 1-5.627 2.796C5.17 16 2.011 12.86 2.011 9c0-3.86 3.16-7 7.042-7 .77 0 1.511.125 2.205.353v2.461H9.03c-2.338 0-4.24 1.89-4.24 4.215 0 2.324 1.902 4.214 4.24 4.214s4.24-1.89 4.24-4.214V3.396v.001-2.36A9.05 9.05 0 0 0 9.054 0C4.053 0 0 4.03 0 9s4.053 9 9.053 9a9.05 9.05 0 0 0 7.058-3.366 7 7 0 0 1-1.431-1.429" mask="url(#dacr-license-icon_svg__b)"></path></g></g>', 2)
  ])]);
}
const Er = { render: i0 }, c0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function a0(n, t) {
  return e(), r("svg", c0, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.923 13.038a2.957 2.957 0 0 1-2.954 2.954 2.957 2.957 0 0 1-2.954-2.954 2.957 2.957 0 0 1 2.954-2.953h2.954zm7.7-5.62h-3.147A9.3 9.3 0 0 1 22.334 13c0 5.147-4.187 9.334-9.334 9.334S3.666 18.147 3.666 13 7.853 3.666 13 3.666a9.3 9.3 0 0 1 2.923.471V7.42h-2.954a5.626 5.626 0 0 0-5.62 5.62 5.626 5.626 0 0 0 5.62 5.62 5.626 5.626 0 0 0 5.62-5.62V2.381A11.94 11.94 0 0 0 13 1C6.373 1 1 6.373 1 13s5.373 12 12 12 12-5.373 12-12c0-2.016-.5-3.914-1.377-5.581"
    }, null, -1)
  ])]);
}
const Gr = { render: a0 }, h0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function p0(n, t) {
  return e(), r("svg", h0, [...t[0] || (t[0] = [
    s('<defs><path id="database_svg__a" d="M12 .75c6.213 0 11.25 2.015 11.25 4.5v13.499c0 2.485-5.037 4.5-11.25 4.5S.75 21.234.75 18.749V5.25C.75 2.765 5.787.75 12 .75"></path></defs><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"><path d="M1.75 6.25c0 2.485 5.037 4.5 11.25 4.5s11.25-2.015 11.25-4.5-5.037-4.5-11.25-4.5S1.75 3.765 1.75 6.25"></path><path d="M1.75 6.25v6.749c0 2.485 5.037 4.5 11.25 4.5s11.25-2.014 11.25-4.5V6.25"></path><path d="M1.75 12.999v6.75c0 2.485 5.037 4.5 11.25 4.5s11.25-2.015 11.25-4.5v-6.75"></path></g>', 2)
  ])]);
}
const Or = { render: p0 }, d0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function x0(n, t) {
  return e(), r("svg", d0, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M1.75 13c0 6.214 5.036 11.25 11.25 11.25S24.25 19.214 24.25 13 19.214 1.75 13 1.75 1.75 6.786 1.75 13M5.046 20.952 20.954 5.046" })
    ], -1)
  ])]);
}
const Pr = { render: x0 }, w0 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 40 26",
  style: { "container-type": "size", "aspect-ratio": "40/26", "--icon-vw": "40px", "--icon-vh": "26px" }
};
function v0(n, t) {
  return e(), r("svg", w0, [...t[0] || (t[0] = [
    s('<defs><path id="discover_svg__a" d="M4 0h32a4 4 0 0 1 4 4v18a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4"></path><path id="discover_svg__b" d="M0 0h4.168v5.064H0z"></path><path id="discover_svg__d" d="M0 5.388h32V0H0z"></path><linearGradient id="discover_svg__f" x1="22.434%" x2="74.451%" y1="17.764%" y2="82.136%"><stop offset="0%" stop-color="#D94020"></stop><stop offset="100%" stop-color="#F59314"></stop><stop offset="100%" stop-color="#F59314"></stop></linearGradient></defs><g fill="none"><path stroke="#424446" stroke-linejoin="square" stroke-opacity=".25" d="M39.5 4v18a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 22V4A3.5 3.5 0 0 1 4 .5h32A3.5 3.5 0 0 1 39.5 4Z" data-icon-stroke="" style="--icon-sw:1px;stroke-width:calc(1px*max(40px/100cqw,26px/100cqh));"></path><g fill-rule="evenodd" transform="translate(4 10)"><g transform="translate(0 .145)"><mask id="discover_svg__c" fill="#fff"><use xlink:href="#discover_svg__b"></use></mask><path fill="#201D1C" d="M1.45 0H0v5.064h1.442c.767 0 1.32-.181 1.807-.585a2.54 2.54 0 0 0 .919-1.944C4.168 1.041 3.052 0 1.45 0m1.154 3.804c-.311.28-.714.402-1.352.402H.987V.858h.265c.638 0 1.026.114 1.352.409.34.305.547.776.547 1.261 0 .486-.206.972-.547 1.276" mask="url(#discover_svg__c)"></path></g><mask id="discover_svg__e" fill="#fff"><use xlink:href="#discover_svg__d"></use></mask><path fill="#201D1C" d="M4.623 5.208h.988V.144h-.988zM8.026 2.088c-.593-.22-.767-.364-.767-.638 0-.318.31-.561.736-.561.296 0 .539.122.797.41l.516-.676A2.2 2.2 0 0 0 7.82.06c-.896 0-1.58.622-1.58 1.45 0 .699.319 1.056 1.247 1.39.387.136.583.227.683.288a.61.61 0 0 1 .296.524c0 .41-.326.714-.767.714-.471 0-.851-.235-1.078-.675l-.638.614c.455.668 1 .964 1.753.964 1.026 0 1.746-.682 1.746-1.662 0-.805-.332-1.17-1.456-1.58M9.794 2.68c0 1.488 1.169 2.643 2.673 2.643.425 0 .789-.084 1.238-.296V3.865c-.395.395-.744.554-1.192.554-.995 0-1.701-.721-1.701-1.746 0-.973.728-1.74 1.655-1.74.47 0 .828.169 1.238.57V.34C13.272.12 12.915.03 12.49.03c-1.496 0-2.696 1.178-2.696 2.65M21.536 3.546 20.186.145h-1.079l2.148 5.193h.532L23.975.145h-1.07zM24.422 5.208h2.8v-.857H25.41V2.984h1.747v-.858h-1.747V1.002h1.814V.144h-2.801zM31.134 1.64c0-.948-.653-1.495-1.792-1.495h-1.465v5.064h.987V3.175h.129l1.367 2.034h1.214L29.98 3.076c.744-.152 1.154-.662 1.154-1.436m-1.982.835h-.288V.942h.304c.615 0 .95.258.95.75 0 .51-.335.783-.966.783M31.764.335c0-.09-.06-.137-.168-.137h-.143v.445h.106V.47l.124.173h.13l-.146-.184c.062-.017.097-.062.097-.124m-.187.06h-.018V.28h.02q.079 0 .08.058-.001.059-.082.059" mask="url(#discover_svg__e)"></path><path fill="#201D1C" d="M31.617.031a.388.388 0 1 0 0 .776A.386.386 0 0 0 32 .42a.387.387 0 0 0-.383-.388m-.001.707a.314.314 0 0 1-.31-.318c0-.178.138-.319.31-.319.169 0 .307.145.307.32a.313.313 0 0 1-.307.317" mask="url(#discover_svg__e)"></path><path fill="url(#discover_svg__f)" d="M19.415 2.694a2.694 2.694 0 1 1-5.387 0 2.694 2.694 0 0 1 5.387 0" mask="url(#discover_svg__e)"></path></g></g>', 2)
  ])]);
}
const Rr = { render: v0 }, u0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function k0(n, t) {
  return e(), r("svg", u0, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M13 2v17.335" }),
      o("path", {
        "stroke-linecap": "square",
        "stroke-linejoin": "round",
        d: "m7 13.334 6 6 6-6"
      }),
      o("path", {
        "stroke-linecap": "square",
        d: "M24 24H2"
      })
    ], -1)
  ])]);
}
const Wr = { render: k0 }, M0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function f0(n, t) {
  return e(), r("svg", M0, [...t[0] || (t[0] = [
    o("g", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.224",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.224px", "stroke-width": "calc(1.224px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M8.1 19.578a1.45 1.45 0 1 0 2.9 0 1.45 1.45 0 0 0-2.9 0M15 19.578a1.45 1.45 0 1 0 2.9 0 1.45 1.45 0 0 0-2.9 0M8.1 13.014a1.45 1.45 0 1 0 2.9 0 1.45 1.45 0 0 0-2.9 0M15 13.014a1.45 1.45 0 1 0 2.9 0 1.45 1.45 0 0 0-2.9 0M8.1 6.45a1.45 1.45 0 1 0 2.9 0 1.45 1.45 0 0 0-2.9 0M15 6.45a1.45 1.45 0 1 0 2.9 0 1.45 1.45 0 0 0-2.9 0" })
    ], -1)
  ])]);
}
const Ur = { render: f0 }, g0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function z0(n, t) {
  return e(), r("svg", g0, [...t[0] || (t[0] = [
    o("defs", null, [
      o("path", {
        id: "drums_svg__a",
        d: "m20.246 21.776-8.998-.015 4.709-10.513Zm-8.998-.015-8.997-.015 4.708-10.378Zm5.557-15.11a1.874 1.874 0 1 1-3.749.001 1.874 1.874 0 0 1 3.749-.001m-6.749-.135v.002a1.876 1.876 0 0 1-3.75-.002v-.002a1.876 1.876 0 0 1 3.75.002"
      })
    ], -1),
    o("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M8.306 8.516a1.875 1.875 0 0 0 3.75.002v-.002a1.875 1.875 0 0 0-3.75-.002zM8.853 7.192 3.17 2.75M15.055 8.651a1.874 1.874 0 1 0 3.749.001 1.874 1.874 0 0 0-3.749-.001M18.31 7.381l5.856-4.212M23.636 13.248H2.96M2.75 23.746l20.996.03M4.251 23.746l4.708-10.378 4.289 10.393 4.709-10.513 4.289 10.528M4.251 13.248v10.498M22.246 13.278v10.498" })
    ], -1)
  ])]);
}
const Nr = { render: z0 }, _0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function m0(n, t) {
  return e(), r("svg", _0, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "square",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "m16.4 6 6.667 6.667-6.667 6.666M9.667 19.333 3 12.667 9.667 6" })
    ], -1)
  ])]);
}
const Tr = { render: m0 }, y0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function C0(n, t) {
  return e(), r("svg", y0, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M19.002 13.334H1.666" }),
      o("path", {
        "stroke-linecap": "square",
        d: "m7.667 7.334-6 6 6 6M23.667 2.334v22"
      })
    ], -1)
  ])]);
}
const Qr = { render: C0 }, q0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function $0(n, t) {
  return e(), r("svg", q0, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M12.691 13.024 24 2M24 11.895V2H13.943M10.01 2H3.1A1.1 1.1 0 0 0 2 3.1v19.8A1.1 1.1 0 0 0 3.1 24h19.8a1.1 1.1 0 0 0 1.1-1.1v-6.91" })
    ], -1)
  ])]);
}
const Jr = { render: $0 }, B0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function I0(n, t) {
  return e(), r("svg", B0, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "m4.029 22 18.75-18M10.249 20.05a9.9 9.9 0 0 0 3 .45c4.1.07 8.26-2.81 10.82-5.64a1.65 1.65 0 0 0 0-2.22 20 20 0 0 0-3.07-2.76M18.339 8.27A11.3 11.3 0 0 0 13.249 7c-4-.07-8.2 2.75-10.82 5.64a1.65 1.65 0 0 0 0 2.22 20 20 0 0 0 4.93 4" }),
      o("path", { d: "M10.249 16.07a3.85 3.85 0 0 1 5.5-5.28M16.999 13.75a3.75 3.75 0 0 1-3.75 3.75" })
    ], -1)
  ])]);
}
const Kr = { render: I0 }, V0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function H0(n, t) {
  return e(), r("svg", V0, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M13.249 7.001c-4.031-.068-8.2 2.75-10.821 5.634a1.663 1.663 0 0 0 0 2.226c2.564 2.824 6.72 5.706 10.82 5.637 4.1.07 8.259-2.813 10.825-5.637.57-.633.57-1.593 0-2.226-2.625-2.885-6.794-5.702-10.824-5.634" }),
      o("path", { d: "M16.998 13.75a3.75 3.75 0 1 1-7.5.004 3.75 3.75 0 0 1 7.5-.007z" })
    ], -1)
  ])]);
}
const Xr = { render: H0 }, A0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  style: { "container-type": "size", "aspect-ratio": "16/16", "--icon-vw": "16px", "--icon-vh": "16px" }
};
function j0(n, t) {
  return e(), r("svg", A0, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      o("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M8.022 3c-2.48-.05-5.046 2.037-6.659 4.174-.35.47-.35 1.18 0 1.65 1.578 2.091 4.136 4.226 6.66 4.175 2.522.051 5.081-2.084 6.66-4.176.35-.469.35-1.18 0-1.649-1.615-2.137-4.18-4.223-6.66-4.173",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(16px/100cqw,16px/100cqh))" }
      }),
      o("path", {
        fill: "currentColor",
        d: "M10.33 8a2.308 2.308 0 1 1-4.616.003 2.308 2.308 0 0 1 4.616-.005z"
      })
    ], -1)
  ])]);
}
const Yr = { render: j0 }, L0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function F0(n, t) {
  return e(), r("svg", L0, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M25 12.997C24.998 6.369 19.624.998 12.997 1 6.369 1.002.998 6.376 1 13.003a12 12 0 0 0 10.125 11.85v-8.388H8.078v-3.468h3.047v-2.644c0-3.008 1.791-4.67 4.533-4.67.9.013 1.799.092 2.688.235v2.953H16.83c-1.49 0-1.955.925-1.955 1.872v2.251h3.328l-.532 3.47h-2.796v8.385A12 12 0 0 0 25 12.997"
    }, null, -1)
  ])]);
}
const t5 = { render: F0 }, b0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function S0(n, t) {
  return e(), r("svg", b0, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M22.061 6.561c.281.281.439.662.439 1.06V22a2.25 2.25 0 0 1-1.391 2.077 2.3 2.3 0 0 1-.861.171H5.747A2.25 2.25 0 0 1 3.5 22V4a2.25 2.25 0 0 1 2.247-2.25h10.882a1.5 1.5 0 0 1 1.06.439zM12.25 8.673a.75.75 0 0 1 1.5 0v3.577h3.577a.75.75 0 0 1 0 1.5H13.75v3.577a.75.75 0 0 1-1.5 0V13.75H8.673a.75.75 0 0 1 0-1.5h3.577z"
    }, null, -1)
  ])]);
}
const o5 = { render: S0 }, D0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Z0(n, t) {
  return e(), r("svg", D0, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1px", "stroke-width": "calc(1px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", {
        "stroke-width": "1.5",
        d: "M22.061 6.561c.281.281.439.662.439 1.06V22a2.25 2.25 0 0 1-1.391 2.077 2.3 2.3 0 0 1-.861.171H5.747A2.25 2.25 0 0 1 3.5 22V4a2.25 2.25 0 0 1 2.247-2.25h10.882a1.5 1.5 0 0 1 1.06.439z",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
      }),
      o("g", {
        "stroke-width": "1.5",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
      }, [
        o("path", { d: "M8.673 13h8.654M13 8.673v8.654" })
      ])
    ], -1)
  ])]);
}
const e5 = { render: Z0 }, E0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function G0(n, t) {
  return e(), r("svg", E0, [...t[0] || (t[0] = [
    o("g", {
      fill: "currentColor",
      "fill-rule": "nonzero"
    }, [
      o("path", { d: "m19.976 1.523 3.221 3.109c.353.34.553.806.553 1.293v10.226a2.334 2.334 0 0 1-.715 1.67 2.4 2.4 0 0 1-.782.504c-.29.116-.6.175-.912.175H18.02a.75.75 0 0 1-.75-.75v-1.954a4.25 4.25 0 0 0-1.22-2.98l-3.693-3.758a4.25 4.25 0 0 0-3.031-1.27H9a.75.75 0 0 1-.75-.75V3.35c0-.628.258-1.229.714-1.67A2.44 2.44 0 0 1 10.656 1h8.018c.486 0 .954.187 1.302.523" }),
      o("path", { d: "m10.745 10.973 3.53 3.526c.304.303.475.714.475 1.143v7.309A2.05 2.05 0 0 1 12.696 25H4.3a2.054 2.054 0 0 1-2.05-2.049v-10.4A2.05 2.05 0 0 1 4.3 10.5h5.301c.429 0 .84.17 1.144.473" })
    ], -1)
  ])]);
}
const r5 = { render: G0 }, O0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function P0(n, t) {
  return e(), r("svg", O0, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M9 7.037V3.35c0-.424.175-.83.485-1.13s.732-.47 1.17-.47h8.019c.293 0 .574.112.781.312l3.222 3.11c.207.2.323.47.323.753v10.226a1.587 1.587 0 0 1-.486 1.13 1.7 1.7 0 0 1-.539.347c-.201.08-.417.122-.634.122H18.02M13.746 15.03a.87.87 0 0 1 .254.612v7.309a1.3 1.3 0 0 1-1.304 1.299H4.301A1.304 1.304 0 0 1 3 22.951v-10.4a1.3 1.3 0 0 1 1.3-1.301h5.301a.87.87 0 0 1 .614.254z" })
    ], -1)
  ])]);
}
const n5 = { render: P0 }, R0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function W0(n, t) {
  return e(), r("svg", R0, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M22.061 6.561c.281.281.439.662.439 1.06V22a2.25 2.25 0 0 1-1.391 2.077 2.3 2.3 0 0 1-.861.171H5.747A2.25 2.25 0 0 1 3.5 22V4a2.25 2.25 0 0 1 2.247-2.25h10.882a1.5 1.5 0 0 1 1.06.439zM13 13V8"
      }),
      o("path", { d: "M13 17.75a.25.25 0 0 1 0-.5M13 17.75a.25.25 0 0 0 0-.5" })
    ], -1)
  ])]);
}
const s5 = { render: W0 }, U0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function N0(n, t) {
  return e(), r("svg", U0, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      o("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M22.061 6.561c.281.281.439.662.439 1.06V22a2.25 2.25 0 0 1-1.391 2.077 2.3 2.3 0 0 1-.861.171H5.747A2.25 2.25 0 0 1 3.5 22V4a2.25 2.25 0 0 1 2.247-2.25h10.882a1.5 1.5 0 0 1 1.06.439z",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
      }),
      o("path", {
        fill: "currentColor",
        d: "M14.332 17.244a2.224 2.224 0 0 1-2.228-2.215V7.036h-2.012v7.993c0 2.324 1.903 4.215 4.24 4.215H17v-2z"
      })
    ], -1)
  ])]);
}
const l5 = { render: N0 }, T0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Q0(n, t) {
  return e(), r("svg", T0, [...t[0] || (t[0] = [
    s('<g fill="none" fill-rule="evenodd" stroke="currentColor" data-icon-stroke="" style="--icon-sw:1px;stroke-width:calc(1px*max(26px/100cqw,26px/100cqh));"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M22.061 6.561c.281.281.439.662.439 1.06V22a2.25 2.25 0 0 1-1.391 2.077 2.3 2.3 0 0 1-.861.171H5.747A2.25 2.25 0 0 1 3.5 22V4a2.25 2.25 0 0 1 2.247-2.25h10.882a1.5 1.5 0 0 1 1.06.439z" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"></path><g stroke-width="1.5" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"><path d="M2.947 13.192H17.1"></path><path stroke-linecap="square" stroke-linejoin="round" d="m12.202 18.091 4.899-4.899-4.9-4.899"></path></g></g>', 1)
  ])]);
}
const i5 = { render: Q0 }, J0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function K0(n, t) {
  return e(), r("svg", J0, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1px", "stroke-width": "calc(1px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", {
        "stroke-linecap": "round",
        "stroke-width": "1.5",
        d: "M22.061 6.561c.281.281.439.662.439 1.06V22a2.25 2.25 0 0 1-1.391 2.077 2.3 2.3 0 0 1-.861.171H5.747A2.25 2.25 0 0 1 3.5 22V4a2.25 2.25 0 0 1 2.247-2.25h10.882a1.5 1.5 0 0 1 1.06.439z",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
      }),
      o("g", {
        "stroke-width": "1.5",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
      }, [
        o("path", { d: "M8.653 13.681a3.834 3.834 0 1 0 7.057-2.999 3.834 3.834 0 0 0-7.057 3ZM14.892 14.892l2.974 2.975" })
      ])
    ], -1)
  ])]);
}
const c5 = { render: K0 }, X0 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Y0(n, t) {
  return e(), r("svg", X0, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", {
        "stroke-linecap": "round",
        d: "M22.061 6.561c.281.281.439.662.439 1.06V22a2.25 2.25 0 0 1-1.391 2.077 2.3 2.3 0 0 1-.861.171H5.747A2.25 2.25 0 0 1 3.5 22V4a2.25 2.25 0 0 1 2.247-2.25h10.882a1.5 1.5 0 0 1 1.06.439z"
      }),
      o("path", { d: "M9.75 14.562c0 1.718.93 3.107 3.12 3.107s2.88-1.478 2.88-2.42c0-1.51-1.073-2.28-2.88-2.57-2.144-.343-2.85-1.181-2.85-2.287 0-1.583 1.426-2.061 2.73-2.061 1.306 0 2.806.836 2.806 2.645M12.75 6v2.331M12.75 17.669V20" })
    ], -1)
  ])]);
}
const a5 = { render: Y0 }, t2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function o2(n, t) {
  return e(), r("svg", t2, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", {
        "stroke-linecap": "round",
        d: "M22.498 22.75a1.5 1.5 0 0 1-1.5 1.5H5a1.5 1.5 0 0 1-1.5-1.5V3.25A1.5 1.5 0 0 1 5 1.75h13.043c.392 0 .768.153 1.048.426l2.954 2.883c.29.282.453.67.453 1.074z"
      }),
      o("path", {
        "stroke-linecap": "square",
        d: "M8.045 9.25h9.998M8.045 13.75h9.998M8.045 18.25h6"
      })
    ], -1)
  ])]);
}
const h5 = { render: o2 }, e2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function r2(n, t) {
  return e(), r("svg", e2, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.667",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.667px", "stroke-width": "calc(1.667px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M3 6.457h20M5.13 11.152h15.74M10.084 20.543h5.832M7.26 15.848h11.48" })
    ], -1)
  ])]);
}
const p5 = { render: r2 }, n2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function s2(n, t) {
  return e(), r("svg", n2, [...t[0] || (t[0] = [
    o("defs", null, [
      o("path", {
        id: "flag_svg__a",
        d: "M3.904 2.676a9.6 9.6 0 0 1 7.864 1 9.62 9.62 0 0 0 7.679 1.056l2.369-.677q.15-.043.307-.043a1.126 1.126 0 0 1 1.127 1.125v11.727c0 .502-.333.944-.816 1.082l-2.987.854a9.62 9.62 0 0 1-7.679-1.062 9.6 9.6 0 0 0-7.864-1l-3.154.97V3.645Z"
      })
    ], -1),
    o("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M1.75 24.25V1.75M1.75 18.708l3.154-.97a9.6 9.6 0 0 1 7.864 1 9.62 9.62 0 0 0 7.679 1.062l2.987-.854c.483-.138.816-.58.816-1.082V6.137a1.126 1.126 0 0 0-1.434-1.082l-2.369.677a9.62 9.62 0 0 1-7.679-1.056 9.6 9.6 0 0 0-7.864-1l-3.154.969" })
    ], -1)
  ])]);
}
const d5 = { render: s2 }, l2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function i2(n, t) {
  return e(), r("svg", l2, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1px", "stroke-width": "calc(1px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", {
        "stroke-width": "1.5",
        d: "M24 8a2 2 0 0 0-2-2H10L8.587 4.585A2 2 0 0 0 7.172 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2z",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
      }),
      o("g", {
        "stroke-width": "1.5",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
      }, [
        o("path", { d: "M9.539 14h6.923M13 10.539v6.923" })
      ])
    ], -1)
  ])]);
}
const x5 = { render: i2 }, c2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function a2(n, t) {
  return e(), r("svg", c2, [...t[0] || (t[0] = [
    o("path", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M24 8a2 2 0 0 0-2-2H10L8.587 4.585A2 2 0 0 0 7.172 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2z",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, null, -1)
  ])]);
}
const w5 = { render: a2 }, h2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function p2(n, t) {
  return e(), r("svg", h2, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M11.79 3.684a1.957 1.957 0 0 0 2.908 0l.946-1.038a1.958 1.958 0 0 1 3.41 1.413l-.071 1.4a1.96 1.96 0 0 0 2.05 2.054l1.4-.071a1.959 1.959 0 0 1 1.41 3.41l-1.041.94a1.96 1.96 0 0 0 0 2.909l1.042.94a1.958 1.958 0 0 1-1.413 3.41l-1.4-.071a1.96 1.96 0 0 0-2.056 2.056l.07 1.4a1.959 1.959 0 0 1-3.401 1.41l-.941-1.041a1.96 1.96 0 0 0-2.908 0l-.945 1.04a1.959 1.959 0 0 1-3.406-1.407l.072-1.4a1.96 1.96 0 0 0-2.056-2.056l-1.4.07a1.957 1.957 0 0 1-1.416-3.406l1.04-.94a1.96 1.96 0 0 0 0-2.91l-1.04-.944a1.959 1.959 0 0 1 1.409-3.406l1.4.07a1.96 1.96 0 0 0 2.058-2.06l-.067-1.4a1.959 1.959 0 0 1 3.406-1.41z" }),
      o("path", { d: "M8.744 13.247a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0" })
    ], -1)
  ])]);
}
const v5 = { render: p2 }, d2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 26",
  style: { "container-type": "size", "aspect-ratio": "40/26", "--icon-vw": "40px", "--icon-vh": "26px" }
};
function x2(n, t) {
  return e(), r("svg", d2, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      o("rect", {
        width: "39",
        height: "25",
        x: ".5",
        y: ".5",
        fill: "#F6F6F6",
        stroke: "#424446",
        "stroke-opacity": ".25",
        rx: "4",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1px", "stroke-width": "calc(1px*max(40px/100cqw,26px/100cqh))" }
      }),
      o("path", {
        fill: "#424446",
        "fill-opacity": ".25",
        d: "M1 6h38v6H1z"
      })
    ], -1)
  ])]);
}
const u5 = { render: x2 }, w2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28",
  style: { "container-type": "size", "aspect-ratio": "28/28", "--icon-vw": "28px", "--icon-vh": "28px" }
};
function v2(n, t) {
  return e(), r("svg", w2, [...t[0] || (t[0] = [
    s('<g fill="none"><g fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(28px/100cqw,28px/100cqh));"><path d="M13.25 2C19.463 2 24.5 7.037 24.5 13.25S19.463 24.5 13.25 24.5 2 19.463 2 13.25 7.037 2 13.25 2"></path><path d="M11.13 24.3c-1.57-2.2-2.63-6.33-2.63-11s1.06-8.9 2.63-11.05M15.37 24.3c1.57-2.2 2.63-6.33 2.63-11s-1.06-8.9-2.63-11.05M2 13.25h22.5M3.3 18.5h19.9M3.3 8h19.9"></path></g><g fill="currentColor"><path stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M25.925 20.144a.75.75 0 0 1-.75.75H15.113a.75.75 0 0 1 0-1.5h10.062a.75.75 0 0 1 .75.75m-5.03-5.03v10.061a.75.75 0 0 1-1.5 0V15.113a.75.75 0 0 1 1.5 0" data-icon-stroke="" style="--icon-sw:4px;stroke-width:calc(4px*max(28px/100cqw,28px/100cqh));"></path><path d="M25.925 20.144a.75.75 0 0 1-.75.75H15.113a.75.75 0 0 1 0-1.5h10.062a.75.75 0 0 1 .75.75m-5.03-5.03v10.061a.75.75 0 0 1-1.5 0V15.113a.75.75 0 0 1 1.5 0"></path></g></g>', 1)
  ])]);
}
const k5 = { render: v2 }, u2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function k2(n, t) {
  return e(), r("svg", u2, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M13.25 2C19.463 2 24.5 7.037 24.5 13.25S19.463 24.5 13.25 24.5 2 19.463 2 13.25 7.037 2 13.25 2" }),
      o("path", { d: "M11.13 24.3c-1.57-2.2-2.63-6.33-2.63-11s1.06-8.9 2.63-11.05M15.37 24.3c1.57-2.2 2.63-6.33 2.63-11s-1.06-8.9-2.63-11.05M2 13.25h22.5M3.3 18.5h19.9M3.3 8h19.9" })
    ], -1)
  ])]);
}
const M5 = { render: k2 }, M2 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 26 26"
};
function f2(n, t) {
  return e(), r("svg", M2, [...t[0] || (t[0] = [
    s('<defs><path id="google_svg__a" d="M0 0h18.758v9.704H0z"></path></defs><g fill="none" fill-rule="evenodd"><path fill="#4285F4" d="M24.701 13.274c0-.877-.078-1.716-.224-2.524H13.201v4.624l6.494.002a5.56 5.56 0 0 1-2.41 3.724v3h3.866c2.257-2.09 3.55-5.178 3.55-8.826"></path><path fill="#34A853" d="M17.286 19.1c-1.076.726-2.461 1.15-4.082 1.15-3.132 0-5.789-2.11-6.74-4.954H2.476v3.093A12 12 0 0 0 13.204 25c3.242 0 5.966-1.066 7.948-2.902z"></path><path fill="#FABB05" d="M6.089 13c0-.798.133-1.57.375-2.296V7.611H2.476A11.94 11.94 0 0 0 1.2 13c0 1.939.461 3.769 1.276 5.39l3.988-3.094a7.2 7.2 0 0 1-.375-2.296"></path><g transform="translate(2.476 1)"><mask id="google_svg__b" fill="#fff"><use xlink:href="#google_svg__a"></use></mask><path fill="#E94235" d="M10.727 4.75c1.77 0 3.354.61 4.606 1.8l3.425-3.423C16.678 1.19 13.965 0 10.728 0 6.037 0 1.975 2.69 0 6.61l3.988 3.094c.951-2.844 3.608-4.954 6.74-4.954" mask="url(#google_svg__b)"></path></g></g>', 2)
  ])]);
}
const f5 = { render: f2 }, g2 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 26 26"
};
function z2(n, t) {
  return e(), r("svg", g2, [...t[0] || (t[0] = [
    s('<defs><path id="google-play_svg__a" d="M15.443 6.866h6.317V17.17h-6.354l.015.015L4.09 23.638a2.747 2.747 0 0 1-4-1.62l-.05-.228a2.7 2.7 0 0 1-.04-.463V2.687q0-.353.09-.69V0h15.353Z"></path><path id="google-play_svg__b" d="M0 0h11.833v10.303H0z"></path><path id="google-play_svg__d" d="M0 0h15.353v12.006H0z"></path></defs><g fill="none" fill-rule="evenodd"><path fill="#EA4335" d="M12.66 12.466 2.59 23.017a2.747 2.747 0 0 0 4 1.621l11.331-6.454z"></path><g transform="translate(12.428 7.866)"><mask id="google-play_svg__c" fill="#fff"><use xlink:href="#google-play_svg__b"></use></mask><path fill="#FBBC04" d="M10.416 2.807 5.516 0 0 4.84l5.538 5.463 4.863-2.776a2.657 2.657 0 0 0 1.132-3.583l-.007-.012a2.7 2.7 0 0 0-1.125-1.125z" mask="url(#google-play_svg__c)"></path></g><path fill="#4285F4" d="M2.59 2.996q-.09.339-.09.69v18.64q0 .352.09.691l10.416-10.28z"></path><g transform="translate(2.59 1)"><mask id="google-play_svg__e" fill="#fff"><use xlink:href="#google-play_svg__d"></use></mask><path fill="#34A853" d="m10.146 12.006 5.207-5.14L4.037.382A2.8 2.8 0 0 0 2.634 0 2.73 2.73 0 0 0 0 1.988z" mask="url(#google-play_svg__e)"></path></g></g>', 2)
  ])]);
}
const g5 = { render: z2 }, _2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function m2(n, t) {
  return e(), r("svg", _2, [...t[0] || (t[0] = [
    o("defs", null, [
      o("path", {
        id: "guitar-electric_svg__a",
        d: "M10.755 3.845c.362.371.439.935.19 1.39a6.3 6.3 0 0 0-.71 2 3 3 0 0 0 .77 2.53l1.42 1.41c.87.9 1.56.79 4.8 1.06a1.12 1.12 0 0 1 .71 1.88 4 4 0 0 1-3.25 1.26c-1.03-.04-2.23.65-2.23 1.76l-.001.121a4.56 4.56 0 0 1-4.64 4.479 5.84 5.84 0 0 1-4.18-1.84l-1.08-1.12a6.12 6.12 0 0 1-1.8-4.28L.75 14.31a4.56 4.56 0 0 1 4.535-4.585c1-.01 1.79-1.44 2-2.49a6.6 6.6 0 0 1 1.9-3.431 1.11 1.11 0 0 1 1.57.041m12.16-2.77a1 1 0 0 1 .098 1.411l-.008.009-3.32 3.4a1.06 1.06 0 0 1-1.498-.047l-.012-.013-1.57-1.6a1.12 1.12 0 0 1-.06-1.55c.15-.205.36-.358.6-.44l4.77-1.46c.36-.098.747.014 1 .29"
      })
    ], -1),
    o("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M20.685 7.895a1.06 1.06 0 0 1-1.498-.047l-.012-.013-1.57-1.6a1.12 1.12 0 0 1-.06-1.55c.15-.205.36-.358.6-.44l4.77-1.46c.36-.098.747.014 1 .29a1 1 0 0 1 .098 1.411l-.008.009zM12.005 11.765a3 3 0 0 1-.77-2.53 6.3 6.3 0 0 1 .71-2 1.18 1.18 0 0 0-.19-1.39 1.11 1.11 0 0 0-1.61 0 6.6 6.6 0 0 0-1.86 3.39c-.21 1.05-1 2.48-2 2.49A4.56 4.56 0 0 0 1.75 16.31q0 .093.005.185a6.12 6.12 0 0 0 1.8 4.28l1.08 1.12a5.84 5.84 0 0 0 4.18 1.84 4.56 4.56 0 0 0 4.639-4.479v-.121c0-1.11 1.2-1.8 2.23-1.76a4 4 0 0 0 3.25-1.26 1.12 1.12 0 0 0-.71-1.88c-3.24-.27-3.93-.16-4.8-1.06zM9.525 14.025l2.07 2.12M12.895 12.655l5.49-5.63" }),
      o("path", { d: "M7.405 16.775c.817 0 1.48.681 1.48 1.52s-.663 1.52-1.48 1.52-1.48-.681-1.48-1.52.663-1.52 1.48-1.52" })
    ], -1)
  ])]);
}
const z5 = { render: m2 }, y2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function C2(n, t) {
  return e(), r("svg", y2, [...t[0] || (t[0] = [
    o("defs", null, [
      o("path", {
        id: "guitar_svg__a",
        d: "M14.642 9.24c1.92 1.92 2.3 4.7.82 6.12a3 3 0 0 1-1.66.83 1.51 1.51 0 0 0-1.24 1.65 4.7 4.7 0 0 1-1.28 4.01c-2.05 2.09-5.82 1.68-8.34-.91s-2.93-6.32-.9-8.37a4.7 4.7 0 0 1 4-1.25 1.51 1.51 0 0 0 1.65-1.24 3 3 0 0 1 .83-1.66c1.42-1.48 4.2-1.1 6.12.82m-5.21 3.71a1.5 1.5 0 1 0 3-.001 1.5 1.5 0 0 0-3 .001M22.063 1.822a1.5 1.5 0 0 1 0 2.12l-1.59 1.592a1.5 1.5 0 1 1-2.122-2.121l1.591-1.591a1.5 1.5 0 0 1 2.121 0"
      })
    ], -1),
    o("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M13.562 18.84a1.51 1.51 0 0 1 1.24-1.65 3 3 0 0 0 1.66-.83c1.48-1.42 1.1-4.2-.82-6.12s-4.7-2.3-6.12-.82a3 3 0 0 0-.83 1.66 1.51 1.51 0 0 1-1.65 1.24 4.7 4.7 0 0 0-4 1.25c-2.03 2.05-1.62 5.78.9 8.37s6.29 3 8.34.91a4.7 4.7 0 0 0 1.28-4.01M19.352 4.413l1.591-1.591a1.5 1.5 0 1 1 2.121 2.12l-1.59 1.592a1.5 1.5 0 1 1-2.122-2.121M19.352 6.53l-3.71 3.71M19.881 1.75l1.061 1.06M23.072 4.94 24.131 6M21.482 6.53l1.059 1.06M18.291 3.34l1.061 1.06" }),
      o("path", { d: "M11.932 12.45a1.5 1.5 0 1 1-.002 3.001 1.5 1.5 0 0 1 .002-3.001M6.101 17.66l2.12 2.12" })
    ], -1)
  ])]);
}
const _5 = { render: C2 }, q2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function $2(n, t) {
  return e(), r("svg", q2, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      transform: "translate(1.75 1.75)"
    }, [
      o("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M8.25 8.25a2.998 2.998 0 0 1 4.732-2.45 3.003 3.003 0 0 1-.732 5.278 1.5 1.5 0 0 0-1 1.415v.256",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
      }),
      o("circle", {
        cx: "11.25",
        cy: "16.25",
        r: "1.25",
        fill: "currentColor"
      }),
      o("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M11.25 22.5c6.213 0 11.25-5.037 11.25-11.25S17.463 0 11.25 0 0 5.037 0 11.25 5.037 22.5 11.25 22.5",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
      })
    ], -1)
  ])]);
}
const m5 = { render: $2 }, B2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function I2(n, t) {
  return e(), r("svg", B2, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M23.631 10.018 13.005 2 2.369 10.018A1.15 1.15 0 0 0 2 10.8v12.244a.96.96 0 0 0 .956.956h6.377v-5.13a3.667 3.667 0 0 1 7.334 0v5.133h6.376a.96.96 0 0 0 .957-.956V10.8a1.15 1.15 0 0 0-.369-.782",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, null, -1)
  ])]);
}
const y5 = { render: I2 }, V2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function H2(n, t) {
  return e(), r("svg", V2, [...t[0] || (t[0] = [
    o("path", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M23.631 10.018 13.005 2 2.369 10.018A1.15 1.15 0 0 0 2 10.8v12.244a.96.96 0 0 0 .956.956h6.377v-5.13a3.667 3.667 0 0 1 7.334 0v5.133h6.376a.96.96 0 0 0 .957-.956V10.8a1.15 1.15 0 0 0-.369-.782",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, null, -1)
  ])]);
}
const C5 = { render: H2 }, A2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function j2(n, t) {
  return e(), r("svg", A2, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M3 5.5a3.5 3.5 0 1 0 7 0 3.5 3.5 0 1 0-7 0"
      }),
      o("path", {
        "stroke-linecap": "square",
        d: "m24 23-6.377-9.288c-.502-.734-1.523-.933-2.278-.445q-.258.166-.437.415l-4.373 6.065-2.71-2.11a1.676 1.676 0 0 0-2.395.36L2 23"
      })
    ], -1)
  ])]);
}
const q5 = { render: j2 }, L2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function F2(n, t) {
  return e(), r("svg", L2, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M15.5 17.75h-.75a1.503 1.503 0 0 1-1.5-1.5V12.5a.75.75 0 0 0-.22-.53.75.75 0 0 0-.53-.22h-.75"
      }),
      o("path", { d: "M12.875 8.75a.375.375 0 0 1 0-.75M12.875 8.75a.375.375 0 0 0 0-.75" }),
      o("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M13 24.25c6.213 0 11.25-5.037 11.25-11.25S19.213 1.75 13 1.75 1.75 6.787 1.75 13 6.787 24.25 13 24.25"
      })
    ], -1)
  ])]);
}
const $5 = { render: F2 }, b2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 12",
  style: { "container-type": "size", "aspect-ratio": "12/12", "--icon-vw": "12px", "--icon-vh": "12px" }
};
function S2(n, t) {
  return e(), r("svg", b2, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      transform: "translate(.75 .75)"
    }, [
      o("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M5.25 7.524v-2.05H4.145",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(12px/100cqw,12px/100cqh))" }
      }),
      o("circle", {
        cx: "5.25",
        cy: "3.188",
        r: "1",
        fill: "currentColor"
      }),
      o("rect", {
        width: "10.5",
        height: "10.5",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        rx: "3",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(12px/100cqw,12px/100cqh))" }
      })
    ], -1)
  ])]);
}
const B5 = { render: S2 }, D2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Z2(n, t) {
  return e(), r("svg", D2, [...t[0] || (t[0] = [
    s('<g fill="none" fill-rule="evenodd"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M22.498 22.75a1.5 1.5 0 0 1-1.5 1.5H5a1.5 1.5 0 0 1-1.5-1.5V3.25A1.5 1.5 0 0 1 5 1.75h13.043c.392 0 .768.153 1.048.426l2.954 2.883c.29.282.453.67.453 1.074z" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"></path><path fill="currentColor" d="M13.5 14v-2z"></path><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"><path d="M13 14.695V12.5M13.793 7.493A.878.878 0 0 0 13 7a.876.876 0 0 0-.792.493l-4.633 9.435a.73.73 0 0 0-.075.365.74.74 0 0 0 .382.612c.11.062.235.095.361.095h9.512a.74.74 0 0 0 .361-.095.735.735 0 0 0 .382-.612.75.75 0 0 0-.075-.365z"></path></g></g>', 1)
  ])]);
}
const I5 = { render: Z2 }, E2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function G2(n, t) {
  return e(), r("svg", E2, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13 1.5c3.123 0 3.515.013 4.741.07 1.225.055 2.06.25 2.792.534A5.6 5.6 0 0 1 22.57 3.43c.64.64 1.032 1.28 1.326 2.037.285.732.479 1.568.535 2.792.056 1.226.069 1.618.069 4.741s-.013 3.515-.07 4.741c-.055 1.224-.25 2.06-.534 2.792a5.6 5.6 0 0 1-1.326 2.037 5.6 5.6 0 0 1-2.037 1.326c-.732.285-1.567.479-2.792.535-1.226.056-1.618.069-4.741.069s-3.515-.013-4.741-.07c-1.224-.055-2.06-.25-2.792-.534A5.6 5.6 0 0 1 3.43 22.57a5.6 5.6 0 0 1-1.326-2.037c-.285-.732-.479-1.568-.535-2.792C1.513 16.515 1.5 16.123 1.5 13s.013-3.515.07-4.741c.055-1.224.25-2.06.534-2.792A5.6 5.6 0 0 1 3.43 3.43a5.6 5.6 0 0 1 2.037-1.326c.732-.285 1.568-.479 2.792-.535C9.485 1.513 9.877 1.5 13 1.5m0 2.072c-3.07 0-3.434.012-4.647.067-1.121.051-1.73.239-2.135.396-.537.209-.92.458-1.323.86a3.6 3.6 0 0 0-.86 1.323c-.157.405-.345 1.014-.396 2.135-.055 1.213-.067 1.576-.067 4.647 0 3.07.012 3.434.067 4.647.051 1.121.239 1.73.396 2.135.209.537.458.92.86 1.323.403.402.786.651 1.323.86.405.157 1.014.345 2.135.396 1.212.055 1.576.067 4.647.067 3.07 0 3.435-.012 4.647-.067 1.121-.051 1.73-.239 2.135-.396.537-.209.92-.458 1.323-.86.402-.403.651-.786.86-1.323.157-.405.345-1.014.396-2.135.055-1.213.067-1.576.067-4.647 0-3.07-.012-3.434-.067-4.647-.051-1.121-.239-1.73-.396-2.135a3.6 3.6 0 0 0-.86-1.323 3.6 3.6 0 0 0-1.323-.86c-.405-.157-1.014-.345-2.135-.396-1.213-.055-1.576-.067-4.647-.067m0 3.523a5.905 5.905 0 1 1 0 11.81 5.905 5.905 0 0 1 0-11.81m0 2.072a3.833 3.833 0 1 0 0 7.666 3.833 3.833 0 0 0 0-7.666m6.139-3.686a1.38 1.38 0 1 1 0 2.76 1.38 1.38 0 0 1 0-2.76"
    }, null, -1)
  ])]);
}
const V5 = { render: G2 }, O2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function P2(n, t) {
  return e(), r("svg", O2, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "nonzero",
      d: "M25 22.6h-1.728a.72.72 0 0 1-.48-.144.96.96 0 0 1-.276-.372L21.4 19h-6l-1.2 3.048a.96.96 0 0 1-.264.36.72.72 0 0 1-.48.168H11.8l5.46-13.764h2.268zm-4.236-5.172L18.868 12.4a14 14 0 0 1-.468-1.488q-.108.444-.228.828l-.228.672-1.896 5.028zm-7.56-1.896a16 16 0 0 1-3.492-1.692 13.75 13.75 0 0 0 3.372-6.444H15.4V5.8H9.772a5 5 0 0 0-.24-.672C9.244 4.348 8.92 3.4 8.92 3.4L7.156 4s.48 1.068.72 1.8H1v1.596h2.58A13.5 13.5 0 0 0 7 13.84a20.6 20.6 0 0 1-6 2.52 22 22 0 0 1 1.044 1.656 28 28 0 0 0 6.264-3.012 18.7 18.7 0 0 0 4.272 2.124zM5.356 7.396h5.892a9.72 9.72 0 0 1-2.94 5.34 10.9 10.9 0 0 1-2.952-5.34"
    }, null, -1)
  ])]);
}
const H5 = { render: P2 }, R2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function W2(n, t) {
  return e(), r("svg", R2, [...t[0] || (t[0] = [
    o("defs", null, [
      o("path", {
        id: "legal_svg__a",
        d: "M4.5 16.5a3.75 3.75 0 0 1-3.75-3.75h7.5A3.75 3.75 0 0 1 4.5 16.5m13.5 0a3.75 3.75 0 0 1-3.75-3.75h7.5A3.75 3.75 0 0 1 18 16.5M12.75 2.25a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001"
      })
    ], -1),
    o("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M13.25 23.75v-18M8.75 23.75h9M14.75 4.25H20M6.5 4.25h5.25M11.75 4.25a1.5 1.5 0 1 0 3.001-.001 1.5 1.5 0 0 0-3.001.001M10.25 14.75a3.75 3.75 0 0 1-7.5 0zM6.5 4.25l-3.75 7.5M6.5 4.25l3.75 7.5M23.75 14.75a3.75 3.75 0 0 1-7.5 0zM20 4.25l-3.75 7.5M20 4.25l3.75 7.5" })
    ], -1)
  ])]);
}
const A5 = { render: W2 }, U2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function N2(n, t) {
  return e(), r("svg", U2, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M18 20.1H8.1A1.1 1.1 0 0 1 7 19V6.9" }),
      o("path", { d: "M14 24.1H4.1A1.1 1.1 0 0 1 3 23V10.9M22.5 14.727c0 .703-.57 1.273-1.273 1.273h-8.909c-.702 0-1.273-.57-1.273-1.273V3.273c0-.703.57-1.273 1.273-1.273h6.473c.338 0 .661.134.9.372l2.437 2.437c.238.239.372.562.372.9z" })
    ], -1)
  ])]);
}
const j5 = { render: N2 }, T2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Q2(n, t) {
  return e(), r("svg", T2, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M12 23h3M19.5 12.5a6 6 0 0 0-5.979-6.021A6 6 0 0 0 12 18.288V20h3v-1.712a5.99 5.99 0 0 0 4.5-5.788M13.5 3.5V2M22.5 11H24M3 12.5h1.5M19.864 18.114l1.061 1.061M6.075 4.325l1.061 1.061M19.864 5.386l1.061-1.061M6.075 19.175l1.061-1.061" })
    ], -1)
  ])]);
}
const L5 = { render: Q2 }, J2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function K2(n, t) {
  return e(), r("svg", J2, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M21.098 21.1H17.69v-5.338c0-1.274-.024-2.91-1.773-2.91-1.775 0-2.046 1.386-2.046 2.818v5.43h-3.41V10.122h3.273v1.5h.046c.456-.863 1.569-1.773 3.228-1.773 3.452 0 4.09 2.272 4.09 5.229zM6.615 8.622a1.977 1.977 0 1 1 0-3.955 1.977 1.977 0 0 1 0 3.955M4.908 21.099h3.413V10.123H4.908zM22.797 1.5h-19.6c-.936 0-1.697.743-1.697 1.657V22.84c0 .916.76 1.66 1.698 1.66h19.599c.938 0 1.703-.744 1.703-1.66V3.157c0-.914-.765-1.657-1.703-1.657"
    }, null, -1)
  ])]);
}
const F5 = { render: K2 }, X2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Y2(n, t) {
  return e(), r("svg", X2, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M13.442 19.312a4.973 4.973 0 0 1-6.598 2.376 4.973 4.973 0 0 1-2.376-6.597l1.508-3.204a4.97 4.97 0 0 1 6.596-2.377 4.96 4.96 0 0 1 2.74 3.482" }),
      o("path", { d: "M12.559 6.344a4.973 4.973 0 0 1 6.597-2.376 4.973 4.973 0 0 1 2.376 6.596l-1.507 3.205a4.973 4.973 0 0 1-6.598 2.376 4.95 4.95 0 0 1-2.566-2.858" })
    ], -1)
  ])]);
}
const b5 = { render: Y2 }, tt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function ot(n, t) {
  return e(), r("svg", tt, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "2",
      "data-icon-stroke": "",
      style: { "--icon-sw": "2px", "stroke-width": "calc(2px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "m4 13 18.46-.039" }),
      o("path", {
        "stroke-linecap": "square",
        "stroke-linejoin": "round",
        d: "m14.5 20.922 7.96-7.961L14.5 5"
      })
    ], -1)
  ])]);
}
const S5 = { render: ot }, et = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function rt(n, t) {
  return e(), r("svg", et, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "2",
      "data-icon-stroke": "",
      style: { "--icon-sw": "2px", "stroke-width": "calc(2px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M13.5 1v16.914" }),
      o("path", {
        "stroke-linecap": "square",
        "stroke-linejoin": "round",
        d: "m8.318 12.732 5.182 5.182 5.182-5.182"
      }),
      o("path", {
        "stroke-linecap": "square",
        d: "M23 21.943H4"
      })
    ], -1)
  ])]);
}
const D5 = { render: rt }, nt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function st(n, t) {
  return e(), r("svg", nt, [...t[0] || (t[0] = [
    o("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M21.327 11.333c0 4.603-8.334 11.667-8.334 11.667S4.66 15.936 4.66 11.333a8.334 8.334 0 0 1 16.667 0",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, null, -1)
  ])]);
}
const Z5 = { render: st }, lt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function it(n, t) {
  return e(), r("svg", lt, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M6.5 11H20a1.5 1.5 0 0 1 1.5 1.5V23a1.5 1.5 0 0 1-1.5 1.5H6.5A1.5 1.5 0 0 1 5 23V12.5A1.5 1.5 0 0 1 6.5 11M8 11V7.25a5.25 5.25 0 0 1 10.5 0V11M13.25 16.25v3" })
    ], -1)
  ])]);
}
const E5 = { render: it }, ct = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  style: { "container-type": "size", "aspect-ratio": "16/16", "--icon-vw": "16px", "--icon-vh": "16px" }
};
function at(n, t) {
  return e(), r("svg", ct, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(16px/100cqw,16px/100cqh))" }
    }, [
      o("path", { d: "M3.91 7.077h8.18c.503 0 .91.348.91.778v5.444c0 .43-.407.778-.91.778H3.91c-.503 0-.91-.348-.91-.778V7.855c0-.43.407-.778.91-.778M4.5 7.077V4.731a3.5 3.5 0 0 1 7 0v2.346" })
    ], -1)
  ])]);
}
const G5 = { render: at }, ht = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function pt(n, t) {
  return e(), r("svg", ht, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M2 11V7.25a5.25 5.25 0 0 1 10.5 0V11M9.5 11H23a1.5 1.5 0 0 1 1.5 1.5V23a1.5 1.5 0 0 1-1.5 1.5H9.5A1.5 1.5 0 0 1 8 23V12.5A1.5 1.5 0 0 1 9.5 11M16.25 16.25v3" })
    ], -1)
  ])]);
}
const O5 = { render: pt }, dt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function xt(n, t) {
  return e(), r("svg", dt, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M3.048 4.75h19.904c.579 0 1.048.493 1.048 1.1v14.3c0 .607-.47 1.1-1.048 1.1H3.048c-.579 0-1.048-.493-1.048-1.1V5.85c0-.607.47-1.1 1.048-1.1" }),
      o("path", { d: "m23.645 5.326-8.532 6.562a3.465 3.465 0 0 1-4.226 0L2.355 5.326" })
    ], -1)
  ])]);
}
const P5 = { render: xt }, wt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 26",
  style: { "container-type": "size", "aspect-ratio": "40/26", "--icon-vw": "40px", "--icon-vh": "26px" }
};
function vt(n, t) {
  return e(), r("svg", wt, [...t[0] || (t[0] = [
    s('<g fill="none" fill-rule="evenodd"><rect width="39" height="25" x=".5" y=".5" fill="#F6F6F6" stroke="#424446" stroke-opacity=".25" rx="4" data-icon-stroke="" style="--icon-sw:1px;stroke-width:calc(1px*max(40px/100cqw,26px/100cqh));"></rect><path fill="#FF5A00" d="M16.424 19.289h7V6.71h-7z"></path><path fill="#EB001B" d="M16.89 13a8.02 8.02 0 0 1 3.045-6.289A7.995 7.995 0 0 0 7 13a7.995 7.995 0 0 0 12.935 6.289A7.98 7.98 0 0 1 16.89 13"></path><path fill="#F79E1B" d="M32.87 13a7.995 7.995 0 0 1-12.935 6.289A7.96 7.96 0 0 0 22.979 13a8.02 8.02 0 0 0-3.044-6.289A7.94 7.94 0 0 1 24.867 5c4.424 0 8.002 3.601 8.002 8"></path></g>', 1)
  ])]);
}
const R5 = { render: vt }, ut = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function kt(n, t) {
  return e(), r("svg", ut, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M3 21h19.5M3 13h19.5M3 5h19.5" })
    ], -1)
  ])]);
}
const W5 = { render: kt }, Mt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function ft(n, t) {
  return e(), r("svg", Mt, [...t[0] || (t[0] = [
    o("g", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M2.5 13A1.75 1.75 0 1 0 6 13a1.75 1.75 0 0 0-3.5 0M20 13a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0M11.25 13a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0" })
    ], -1)
  ])]);
}
const U5 = { render: ft }, gt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function zt(n, t) {
  return e(), r("svg", gt, [...t[0] || (t[0] = [
    o("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M1.75 13h22.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, null, -1)
  ])]);
}
const N5 = { render: zt }, _t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function mt(n, t) {
  return e(), r("svg", _t, [...t[0] || (t[0] = [
    s('<g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-width="1.5" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"><path d="M13 10.98v13.355"></path><path stroke-linecap="square" d="M9.045 20.42 13 24.334l3.943-3.914"></path><path d="M12.988 15.335V1.979"></path><path stroke-linecap="square" d="M16.943 5.894 12.988 1.98 9.045 5.894"></path><path d="M10.75 13.043h13.355"></path><path stroke-linecap="square" d="m20.19 16.998 3.915-3.955L20.19 9.1"></path><path d="M15.105 13.055H1.75"></path><path stroke-linecap="square" d="M5.665 9.1 1.75 13.055l3.915 3.943"></path></g>', 1)
  ])]);
}
const T5 = { render: mt }, yt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Ct(n, t) {
  return e(), r("svg", yt, [...t[0] || (t[0] = [
    s('<g fill="none" fill-rule="evenodd"><path fill="currentColor" d="M3.611 21.938a2.437 2.437 0 1 0 4.874 0 2.437 2.437 0 0 0-4.874 0"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3.611 21.938a2.437 2.437 0 1 0 4.874 0 2.437 2.437 0 0 0-4.874 0" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"></path><path fill="currentColor" d="M16.07 18.688a2.437 2.437 0 1 0 4.874 0 2.437 2.437 0 0 0-4.875 0"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16.07 18.688a2.437 2.437 0 1 0 4.874 0 2.437 2.437 0 0 0-4.875 0" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8.486 22.208V6.734A1.53 1.53 0 0 1 9.574 5.26l10.404-3.063a.76.76 0 0 1 .966.74V18.45M8.486 10.834l12.458-3.792" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"></path></g>', 1)
  ])]);
}
const Q5 = { render: Ct }, qt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function $t(n, t) {
  return e(), r("svg", qt, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M13 24.25c6.213 0 11.25-5.037 11.25-11.25S19.213 1.75 13 1.75 1.75 6.787 1.75 13 6.787 24.25 13 24.25M8.196 17.804l9.608-9.608M8.196 8.196l9.608 9.608" })
    ], -1)
  ])]);
}
const J5 = { render: $t }, Bt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function It(n, t) {
  return e(), r("svg", Bt, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M11 2h11.5a1 1 0 0 1 1 1v21a.5.5 0 0 1-.5.5H10.5a.5.5 0 0 1-.5-.5V3a1 1 0 0 1 1-1M10 14v10a.5.5 0 0 1-.5.5h-6A.5.5 0 0 1 3 24V14a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5M6.716 17.632V20M14.25 12.066v2.368M19.104 12.066v2.368M14.25 5.885v2.368M19.104 5.885v2.368" }),
      o("path", { d: "M16.609 19c-.93 0-1.684.754-1.684 1.684V24.5h3.368v-3.816c0-.93-.754-1.684-1.684-1.684" })
    ], -1)
  ])]);
}
const K5 = { render: It }, Vt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Ht(n, t) {
  return e(), r("svg", Vt, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      o("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "m20.887 23.74-5.883-9.726a4.38 4.38 0 0 1-3.19 1.37l3.07 8.81M17.668 18.962l-3.997 1.752",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
      }),
      o("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M8.817 1.98a.646.646 0 0 1 1.086.462c.042 3.313 3.663 3.663 5.073 5.195a4.59 4.59 0 0 1-.26 6.444C9.103 19.248 2.505 7.91 8.817 1.98",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
      }),
      o("path", {
        fill: "currentColor",
        d: "M12.485 6.04s-1.244-.539-2.035-1.704c-.663-.976-.5-2.426-1-2.617C8.7 1.43 5.524 4.805 6.245 8.15c0 0 3.98 2.53 6.24-2.11"
      })
    ], -1)
  ])]);
}
const X5 = { render: Ht }, At = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function jt(n, t) {
  return e(), r("svg", At, [...t[0] || (t[0] = [
    o("g", {
      fill: "currentColor",
      "fill-rule": "evenodd"
    }, [
      o("path", { d: "M4 2h7v22H4zM15 2h7v22h-7z" })
    ], -1)
  ])]);
}
const Y5 = { render: jt }, Lt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Ft(n, t) {
  return e(), r("svg", Lt, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M23.44 3.06a3.64 3.64 0 0 0-5.146.011l-.024.024-14.5 14.5L2 24.5l6.905-1.77 14.5-14.5a3.637 3.637 0 0 0 .061-5.144zM17.856 3.51l5.134 5.134M3.771 17.594l5.139 5.13" })
    ], -1)
  ])]);
}
const tn = { render: Ft }, bt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function St(n, t) {
  return e(), r("svg", bt, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M17.25 2H9a3 3 0 0 0-3 3v16.5a3 3 0 0 0 3 3h8.25a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3"
      }),
      o("path", { d: "M13.125 5.025a.25.25 0 0 1 0-.5M13.125 5.025a.25.25 0 0 0 0-.5" })
    ], -1)
  ])]);
}
const on = { render: St }, Dt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Zt(n, t) {
  return e(), r("svg", Dt, [...t[0] || (t[0] = [
    s('<g fill="none" stroke="currentColor" stroke-width="1.5" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"><rect width="22" height="22" x="2" y="2" rx="2"></rect><g fill-rule="evenodd"><path stroke-linecap="round" stroke-linejoin="round" d="M5.5 8.5a3 3 0 1 0 5.999.001A3 3 0 0 0 5.5 8.5"></path><path stroke-linecap="square" d="m23.5 18.5-6.088-5.573c-.479-.44-1.453-.56-2.174-.267a1.5 1.5 0 0 0-.417.25l-4.545 4.009-2.216-1.637c-.676-.33-1.662-.264-2.204.149q-.044.032-.082.068L2.5 18.5"></path></g></g>', 1)
  ])]);
}
const en = { render: Zt }, Et = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Gt(n, t) {
  return e(), r("svg", Et, [...t[0] || (t[0] = [
    s('<g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-width="1.5" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"><path stroke-linecap="round" stroke-linejoin="round" d="M18.5 24.5a6 6 0 1 0 0-12 6 6 0 0 0 0 12M18.5 15.5v6M15.5 18.5h6"></path><path stroke-linecap="round" stroke-linejoin="round" d="M9.5 21.5h-6A1.503 1.503 0 0 1 2 20V3.5A1.503 1.503 0 0 1 3.5 2h10.629c.398 0 .779.158 1.06.439l2.872 2.872c.281.281.439.662.439 1.06V9.5"></path><path d="M6.5 7.625a.375.375 0 0 1 0-.75M6.5 7.625a.375.375 0 0 0 0-.75"></path><path stroke-linecap="round" stroke-linejoin="round" d="M13.529 11.15 12.5 9.5a.746.746 0 0 0-.966-.251.74.74 0 0 0-.272.237l-2 2.85-1.232-.986a.75.75 0 0 0-1.093.169L5 15.499h4.5"></path></g>', 1)
  ])]);
}
const rn = { render: Gt }, Ot = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Pt(n, t) {
  return e(), r("svg", Ot, [...t[0] || (t[0] = [
    o("defs", null, [
      o("path", {
        id: "piano_svg__a",
        d: "M12.464.843q.208.077.386.212l.55.41a3 3 0 0 1 1.11 1.67c.29 1.18.34 1.92 1.27 2.23l1.51.5c2.3.92 4 3.75 4.37 6.19l.09.56a1.5 1.5 0 0 1 1.5 1.5v4.5a1.5 1.5 0 0 1-1.5 1.5H2.25a1.5 1.5 0 0 1-1.5-1.5v-1.5a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 0 1.5-1.5 1.5 1.5 0 0 1 1.347-1.493l.153-.008 3.8-10.89a1.49 1.49 0 0 1 1.914-.881"
      })
    ], -1),
    o("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M3.25 21.115h19.5a1.5 1.5 0 0 0 1.5-1.5v-4.5a1.5 1.5 0 0 0-1.5-1.5h-15a1.5 1.5 0 0 0-1.5 1.5 1.5 1.5 0 0 1-1.5 1.5h-1.5a1.5 1.5 0 0 0-1.5 1.5v1.5a1.5 1.5 0 0 0 1.5 1.5" }),
      o("path", { d: "m7.75 13.615 3.8-10.89a1.49 1.49 0 0 1 2.3-.67l.55.41a3 3 0 0 1 1.11 1.67c.29 1.18.34 1.92 1.27 2.23l1.51.5c2.3.92 4 3.75 4.37 6.19l.09.56M15.25 13.614 13 9.864M6.25 21.114v3M21.25 21.114v3" })
    ], -1)
  ])]);
}
const nn = { render: Pt }, Rt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Wt(n, t) {
  return e(), r("svg", Rt, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      o("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M13.05 24.5c6.213 0 11.25-5.037 11.25-11.25S19.263 2 13.05 2 1.8 7.037 1.8 13.25 6.837 24.5 13.05 24.5",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
      }),
      o("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M13.08 2 13 13l9.03-6.279",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
      }),
      o("path", {
        fill: "currentColor",
        d: "M13.05 2Q13 2.793 13 13l9.03-6.279Q18.79 2.001 13.05 2"
      })
    ], -1)
  ])]);
}
const sn = { render: Wt }, Ut = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Nt(n, t) {
  return e(), r("svg", Ut, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      o("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M13.05 24.5c6.213 0 11.25-5.037 11.25-11.25S19.263 2 13.05 2 1.8 7.037 1.8 13.25 6.837 24.5 13.05 24.5",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
      }),
      o("path", {
        fill: "currentColor",
        d: "M13.05 2Q13 2.793 13 13l8.046 7.998Q24.301 17.41 24.3 13c0-7.04-6.648-11-11.25-11"
      }),
      o("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M13.08 2 13 13l8.046 7.998",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
      })
    ], -1)
  ])]);
}
const ln = { render: Nt }, Tt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Qt(n, t) {
  return e(), r("svg", Tt, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      o("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M13.05 24.5c6.213 0 11.25-5.037 11.25-11.25S19.263 2 13.05 2 1.8 7.037 1.8 13.25 6.837 24.5 13.05 24.5",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
      }),
      o("path", {
        fill: "currentColor",
        d: "M13.05 2Q13 2.793 13 13l-8.08 7.998q4.798 3.715 8.08 3.715c6.238 0 11.3-5.493 11.3-11.713 0-7.04-6.648-11-11.25-11"
      }),
      o("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M13.08 2 13 13l-8.08 7.998",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
      })
    ], -1)
  ])]);
}
const cn = { render: Qt }, Jt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Kt(n, t) {
  return e(), r("svg", Jt, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      o("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M13.05 24.5c6.213 0 11.25-5.037 11.25-11.25S19.263 2 13.05 2 1.8 7.037 1.8 13.25 6.837 24.5 13.05 24.5",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
      }),
      o("path", {
        fill: "currentColor",
        d: "M13.05 2Q13 2.793 13 13L5.094 5.154Q1.8 8.104 1.8 13c0 5.752 4.805 11.713 11.2 11.713 6.238 0 11.3-5.493 11.3-11.713 0-7.04-6.648-11-11.25-11"
      }),
      o("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M13.08 2 13 13 5.436 5.47",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
      })
    ], -1)
  ])]);
}
const an = { render: Kt }, Xt = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function Yt(n, t) {
  return e(), r("svg", Xt, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      d: "M1 2.007c0-.752.813-1.238 1.498-.895L24.44 12.105a.996.996 0 0 1 0 1.79L2.498 24.888C1.813 25.231 1 24.745 1 23.993Z"
    }, null, -1)
  ])]);
}
const hn = { render: Yt }, to = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function oo(n, t) {
  return e(), r("svg", to, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", {
        "stroke-linecap": "round",
        d: "M13.05 24.5c6.213 0 11.25-5.037 11.25-11.25S19.263 2 13.05 2 1.8 7.037 1.8 13.25 6.837 24.5 13.05 24.5"
      }),
      o("path", { d: "M13 7a4.262 4.262 0 1 1 0 8.524A4.262 4.262 0 0 1 13 7ZM20.37 21.904c-2.038-3.866-7.193-5.677-11.059-3.64-1.412.744-2.9 2.149-3.644 3.561" })
    ], -1)
  ])]);
}
const pn = { render: oo }, eo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function ro(n, t) {
  return e(), r("svg", eo, [...t[0] || (t[0] = [
    s('<g fill="none" fill-rule="evenodd"><path fill="currentColor" d="M7.027 1.405h1v1h-1zM9.135 1.405h1v1h-1z"></path><path fill="currentColor" d="M9.838 1.405h1v1h-1z"></path><path fill="currentColor" d="M10.54 1.405h1v1h-1zM11.946 1.405h1v1h-1zM14.054 1.405h1v1h-1zM17.568 1.405h1v1h-1zM7.73 2.108h1v1h-1z"></path><path fill="currentColor" d="M8.432 2.108h1v1h-1z"></path><path fill="currentColor" d="M9.135 2.108h1v1h-1z"></path><path fill="currentColor" d="M9.838 2.108h1v1h-1z"></path><path fill="currentColor" d="M10.54 2.108h1v1h-1z"></path><path fill="currentColor" d="M11.243 2.108h1v1h-1zM14.054 2.108h1v1h-1z"></path><path fill="currentColor" d="M14.757 2.108h1v1h-1zM8.432 2.81h1v1h-1zM9.838 2.81h1v1h-1zM11.243 2.81h1v1h-1z"></path><path fill="currentColor" d="M11.946 2.81h1v1h-1z"></path><path fill="currentColor" d="M12.649 2.81h1v1h-1z"></path><path fill="currentColor" d="M13.351 2.81h1v1h-1z"></path><path fill="currentColor" d="M14.054 2.81h1v1h-1z"></path><path fill="currentColor" d="M14.757 2.81h1v1h-1zM16.162 2.81h1v1h-1zM17.568 2.81h1v1h-1zM7.027 3.513h1v1h-1z"></path><path fill="currentColor" d="M7.73 3.513h1v1h-1zM9.135 3.513h1v1h-1z"></path><path fill="currentColor" d="M9.838 3.513h1v1h-1zM12.649 3.513h1v1h-1z"></path><path fill="currentColor" d="M13.351 3.513h1v1h-1zM16.162 3.513h1v1h-1z"></path><path fill="currentColor" d="M16.865 3.513h1v1h-1zM7.027 4.216h1v1h-1z"></path><path fill="currentColor" d="M7.73 4.216h1v1h-1zM12.649 4.216h1v1h-1z"></path><path fill="currentColor" d="M13.351 4.216h1v1h-1zM14.757 4.216h1v1h-1zM16.162 4.216h1v1h-1z"></path><path fill="currentColor" d="M16.865 4.216h1v1h-1zM7.027 4.919h1v1h-1z"></path><path fill="currentColor" d="M7.73 4.919h1v1h-1z"></path><path fill="currentColor" d="M8.432 4.919h1v1h-1zM9.838 4.919h1v1h-1zM11.946 4.919h1v1h-1zM13.351 4.919h1v1h-1zM15.46 4.919h1v1h-1z"></path><path fill="currentColor" d="M16.162 4.919h1v1h-1z"></path><path fill="currentColor" d="M16.865 4.919h1v1h-1z"></path><path fill="currentColor" d="M17.568 4.919h1v1h-1z"></path><path fill="currentColor" d="M18.27 4.919h1v1h-1zM7.027 5.622h1v1h-1zM8.432 5.622h1v1h-1zM9.838 5.622h1v1h-1zM11.243 5.622h1v1h-1zM12.649 5.622h1v1h-1zM14.054 5.622h1v1h-1zM15.46 5.622h1v1h-1zM16.865 5.622h1v1h-1z"></path><path fill="currentColor" d="M18.27 5.622h1v1h-1zM7.027 6.324h1v1h-1zM9.135 6.324h1v1h-1zM11.243 6.324h1v1h-1zM13.351 6.324h1v1h-1z"></path><path fill="currentColor" d="M14.054 6.324h1v1h-1z"></path><path fill="currentColor" d="M14.757 6.324h1v1h-1z"></path><path fill="currentColor" d="M15.46 6.324h1v1h-1z"></path><path fill="currentColor" d="M16.162 6.324h1v1h-1zM18.27 6.324h1v1h-1zM1.405 7.027h1v1h-1zM4.216 7.027h1v1h-1zM5.622 7.027h1v1h-1z"></path><path fill="currentColor" d="M6.324 7.027h1v1h-1z"></path><path fill="currentColor" d="M7.027 7.027h1v1h-1zM8.432 7.027h1v1h-1zM9.838 7.027h1v1h-1zM11.946 7.027h1v1h-1zM13.351 7.027h1v1h-1zM15.46 7.027h1v1h-1z"></path><path fill="currentColor" d="M16.162 7.027h1v1h-1z"></path><path fill="currentColor" d="M16.865 7.027h1v1h-1z"></path><path fill="currentColor" d="M17.568 7.027h1v1h-1zM18.973 7.027h1v1h-1z"></path><path fill="currentColor" d="M19.676 7.027h1v1h-1z"></path><path fill="currentColor" d="M20.378 7.027h1v1h-1z"></path><path fill="currentColor" d="M21.081 7.027h1v1h-1z"></path><path fill="currentColor" d="M21.784 7.027h1v1h-1zM23.892 7.027h1v1h-1zM2.108 7.73h1v1h-1zM4.919 7.73h1v1h-1zM6.324 7.73h1v1h-1zM8.432 7.73h1v1h-1z"></path><path fill="currentColor" d="M9.135 7.73h1v1h-1zM11.946 7.73h1v1h-1z"></path><path fill="currentColor" d="M12.649 7.73h1v1h-1z"></path><path fill="currentColor" d="M13.351 7.73h1v1h-1z"></path><path fill="currentColor" d="M14.054 7.73h1v1h-1zM16.162 7.73h1v1h-1z"></path><path fill="currentColor" d="M16.865 7.73h1v1h-1z"></path><path fill="currentColor" d="M17.568 7.73h1v1h-1zM18.973 7.73h1v1h-1zM21.784 7.73h1v1h-1z"></path><path fill="currentColor" d="M22.487 7.73h1v1h-1zM23.892 7.73h1v1h-1zM1.405 8.432h1v1h-1zM2.81 8.432h1v1h-1zM4.216 8.432h1v1h-1z"></path><path fill="currentColor" d="M4.919 8.432h1v1h-1z"></path><path fill="currentColor" d="M5.622 8.432h1v1h-1z"></path><path fill="currentColor" d="M6.324 8.432h1v1h-1z"></path><path fill="currentColor" d="M7.027 8.432h1v1h-1zM10.54 8.432h1v1h-1z"></path><path fill="currentColor" d="M11.243 8.432h1v1h-1z"></path><path fill="currentColor" d="M11.946 8.432h1v1h-1zM14.054 8.432h1v1h-1zM17.568 8.432h1v1h-1zM18.973 8.432h1v1h-1zM21.784 8.432h1v1h-1zM23.19 8.432h1v1h-1zM2.81 9.135h1v1h-1zM4.216 9.135h1v1h-1zM6.324 9.135h1v1h-1zM8.432 9.135h1v1h-1zM9.838 9.135h1v1h-1z"></path><path fill="currentColor" d="M10.54 9.135h1v1h-1zM12.649 9.135h1v1h-1zM14.757 9.135h1v1h-1z"></path><path fill="currentColor" d="M15.46 9.135h1v1h-1zM16.865 9.135h1v1h-1zM18.27 9.135h1v1h-1z"></path><path fill="currentColor" d="M18.973 9.135h1v1h-1z"></path><path fill="currentColor" d="M19.676 9.135h1v1h-1zM1.405 9.838h1v1h-1zM2.81 9.838h1v1h-1z"></path><path fill="currentColor" d="M3.513 9.838h1v1h-1zM5.622 9.838h1v1h-1zM7.027 9.838h1v1h-1zM8.432 9.838h1v1h-1zM9.838 9.838h1v1h-1z"></path><path fill="currentColor" d="M10.54 9.838h1v1h-1zM12.649 9.838h1v1h-1zM16.865 9.838h1v1h-1z"></path><path fill="currentColor" d="M17.568 9.838h1v1h-1z"></path><path fill="currentColor" d="M18.27 9.838h1v1h-1zM19.676 9.838h1v1h-1z"></path><path fill="currentColor" d="M20.378 9.838h1v1h-1zM21.784 9.838h1v1h-1zM23.892 9.838h1v1h-1zM1.405 10.54h1v1h-1zM2.81 10.54h1v1h-1z"></path><path fill="currentColor" d="M3.513 10.54h1v1h-1z"></path><path fill="currentColor" d="M4.216 10.54h1v1h-1z"></path><path fill="currentColor" d="M4.919 10.54h1v1h-1zM6.324 10.54h1v1h-1zM8.432 10.54h1v1h-1z"></path><path fill="currentColor" d="M9.135 10.54h1v1h-1zM11.243 10.54h1v1h-1zM13.351 10.54h1v1h-1z"></path><path fill="currentColor" d="M14.054 10.54h1v1h-1z"></path><path fill="currentColor" d="M14.757 10.54h1v1h-1z"></path><path fill="currentColor" d="M15.46 10.54h1v1h-1zM18.27 10.54h1v1h-1z"></path><path fill="currentColor" d="M18.973 10.54h1v1h-1zM20.378 10.54h1v1h-1zM22.487 10.54h1v1h-1zM2.81 11.243h1v1h-1zM4.216 11.243h1v1h-1z"></path><path fill="currentColor" d="M4.919 11.243h1v1h-1z"></path><path fill="currentColor" d="M5.622 11.243h1v1h-1zM8.432 11.243h1v1h-1z"></path><path fill="currentColor" d="M9.135 11.243h1v1h-1z"></path><path fill="currentColor" d="M9.838 11.243h1v1h-1zM11.243 11.243h1v1h-1z"></path><path fill="currentColor" d="M11.946 11.243h1v1h-1zM13.351 11.243h1v1h-1z"></path><path fill="currentColor" d="M14.054 11.243h1v1h-1zM15.46 11.243h1v1h-1z"></path><path fill="currentColor" d="M16.162 11.243h1v1h-1zM17.568 11.243h1v1h-1z"></path><path fill="currentColor" d="M18.27 11.243h1v1h-1z"></path><path fill="currentColor" d="M18.973 11.243h1v1h-1z"></path><path fill="currentColor" d="M19.676 11.243h1v1h-1zM21.081 11.243h1v1h-1zM23.19 11.243h1v1h-1zM1.405 11.946h1v1h-1z"></path><path fill="currentColor" d="M2.108 11.946h1v1h-1z"></path><path fill="currentColor" d="M2.81 11.946h1v1h-1z"></path><path fill="currentColor" d="M3.513 11.946h1v1h-1z"></path><path fill="currentColor" d="M4.216 11.946h1v1h-1zM6.324 11.946h1v1h-1zM8.432 11.946h1v1h-1z"></path><path fill="currentColor" d="M9.135 11.946h1v1h-1zM10.54 11.946h1v1h-1z"></path><path fill="currentColor" d="M11.243 11.946h1v1h-1z"></path><path fill="currentColor" d="M11.946 11.946h1v1h-1z"></path><path fill="currentColor" d="M12.649 11.946h1v1h-1z"></path><path fill="currentColor" d="M13.351 11.946h1v1h-1z"></path><path fill="currentColor" d="M14.054 11.946h1v1h-1zM16.162 11.946h1v1h-1zM17.568 11.946h1v1h-1zM18.973 11.946h1v1h-1z"></path><path fill="currentColor" d="M19.676 11.946h1v1h-1z"></path><path fill="currentColor" d="M20.378 11.946h1v1h-1zM1.405 12.649h1v1h-1z"></path><path fill="currentColor" d="M2.108 12.649h1v1h-1zM3.513 12.649h1v1h-1z"></path><path fill="currentColor" d="M4.216 12.649h1v1h-1z"></path><path fill="currentColor" d="M4.919 12.649h1v1h-1z"></path><path fill="currentColor" d="M5.622 12.649h1v1h-1zM7.027 12.649h1v1h-1z"></path><path fill="currentColor" d="M7.73 12.649h1v1h-1zM9.838 12.649h1v1h-1zM13.351 12.649h1v1h-1z"></path><path fill="currentColor" d="M14.054 12.649h1v1h-1z"></path><path fill="currentColor" d="M14.757 12.649h1v1h-1z"></path><path fill="currentColor" d="M15.46 12.649h1v1h-1z"></path><path fill="currentColor" d="M16.162 12.649h1v1h-1z"></path><path fill="currentColor" d="M16.865 12.649h1v1h-1zM18.27 12.649h1v1h-1zM19.676 12.649h1v1h-1zM21.081 12.649h1v1h-1z"></path><path fill="currentColor" d="M21.784 12.649h1v1h-1zM23.19 12.649h1v1h-1zM1.405 13.351h1v1h-1z"></path><path fill="currentColor" d="M2.108 13.351h1v1h-1zM4.216 13.351h1v1h-1z"></path><path fill="currentColor" d="M4.919 13.351h1v1h-1zM6.324 13.351h1v1h-1z"></path><path fill="currentColor" d="M7.027 13.351h1v1h-1z"></path><path fill="currentColor" d="M7.73 13.351h1v1h-1z"></path><path fill="currentColor" d="M8.432 13.351h1v1h-1zM11.946 13.351h1v1h-1z"></path><path fill="currentColor" d="M12.649 13.351h1v1h-1zM14.054 13.351h1v1h-1zM15.46 13.351h1v1h-1zM16.865 13.351h1v1h-1z"></path><path fill="currentColor" d="M17.568 13.351h1v1h-1z"></path><path fill="currentColor" d="M18.27 13.351h1v1h-1zM21.784 13.351h1v1h-1z"></path><path fill="currentColor" d="M22.487 13.351h1v1h-1z"></path><path fill="currentColor" d="M23.19 13.351h1v1h-1zM1.405 14.054h1v1h-1zM2.81 14.054h1v1h-1z"></path><path fill="currentColor" d="M3.513 14.054h1v1h-1z"></path><path fill="currentColor" d="M4.216 14.054h1v1h-1zM5.622 14.054h1v1h-1z"></path><path fill="currentColor" d="M6.324 14.054h1v1h-1zM8.432 14.054h1v1h-1zM9.838 14.054h1v1h-1z"></path><path fill="currentColor" d="M10.54 14.054h1v1h-1zM11.946 14.054h1v1h-1z"></path><path fill="currentColor" d="M12.649 14.054h1v1h-1z"></path><path fill="currentColor" d="M13.351 14.054h1v1h-1zM15.46 14.054h1v1h-1z"></path><path fill="currentColor" d="M16.162 14.054h1v1h-1z"></path><path fill="currentColor" d="M16.865 14.054h1v1h-1z"></path><path fill="currentColor" d="M17.568 14.054h1v1h-1z"></path><path fill="currentColor" d="M18.27 14.054h1v1h-1z"></path><path fill="currentColor" d="M18.973 14.054h1v1h-1zM20.378 14.054h1v1h-1zM21.784 14.054h1v1h-1zM23.19 14.054h1v1h-1zM2.108 14.757h1v1h-1z"></path><path fill="currentColor" d="M2.81 14.757h1v1h-1zM4.216 14.757h1v1h-1zM6.324 14.757h1v1h-1zM8.432 14.757h1v1h-1zM9.838 14.757h1v1h-1z"></path><path fill="currentColor" d="M10.54 14.757h1v1h-1zM11.946 14.757h1v1h-1zM13.351 14.757h1v1h-1z"></path><path fill="currentColor" d="M14.054 14.757h1v1h-1zM15.46 14.757h1v1h-1z"></path><path fill="currentColor" d="M16.162 14.757h1v1h-1zM18.27 14.757h1v1h-1z"></path><path fill="currentColor" d="M18.973 14.757h1v1h-1z"></path><path fill="currentColor" d="M19.676 14.757h1v1h-1z"></path><path fill="currentColor" d="M20.378 14.757h1v1h-1zM23.19 14.757h1v1h-1zM1.405 15.46h1v1h-1zM2.81 15.46h1v1h-1zM4.919 15.46h1v1h-1z"></path><path fill="currentColor" d="M5.622 15.46h1v1h-1z"></path><path fill="currentColor" d="M6.324 15.46h1v1h-1zM7.73 15.46h1v1h-1zM9.135 15.46h1v1h-1zM10.54 15.46h1v1h-1z"></path><path fill="currentColor" d="M11.243 15.46h1v1h-1zM14.054 15.46h1v1h-1z"></path><path fill="currentColor" d="M14.757 15.46h1v1h-1z"></path><path fill="currentColor" d="M15.46 15.46h1v1h-1zM19.676 15.46h1v1h-1z"></path><path fill="currentColor" d="M20.378 15.46h1v1h-1z"></path><path fill="currentColor" d="M21.081 15.46h1v1h-1z"></path><path fill="currentColor" d="M21.784 15.46h1v1h-1zM1.405 16.162h1v1h-1zM3.513 16.162h1v1h-1zM4.919 16.162h1v1h-1zM9.838 16.162h1v1h-1zM12.649 16.162h1v1h-1z"></path><path fill="currentColor" d="M13.351 16.162h1v1h-1zM14.757 16.162h1v1h-1zM16.865 16.162h1v1h-1zM19.676 16.162h1v1h-1zM21.784 16.162h1v1h-1z"></path><path fill="currentColor" d="M22.487 16.162h1v1h-1z"></path><path fill="currentColor" d="M23.19 16.162h1v1h-1zM4.216 16.865h1v1h-1z"></path><path fill="currentColor" d="M4.919 16.865h1v1h-1z"></path><path fill="currentColor" d="M5.622 16.865h1v1h-1z"></path><path fill="currentColor" d="M6.324 16.865h1v1h-1zM9.135 16.865h1v1h-1z"></path><path fill="currentColor" d="M9.838 16.865h1v1h-1zM11.243 16.865h1v1h-1zM12.649 16.865h1v1h-1zM14.054 16.865h1v1h-1z"></path><path fill="currentColor" d="M14.757 16.865h1v1h-1zM16.162 16.865h1v1h-1zM17.568 16.865h1v1h-1z"></path><path fill="currentColor" d="M18.27 16.865h1v1h-1z"></path><path fill="currentColor" d="M18.973 16.865h1v1h-1zM22.487 16.865h1v1h-1z"></path><path fill="currentColor" d="M23.19 16.865h1v1h-1zM3.513 17.568h1v1h-1z"></path><path fill="currentColor" d="M4.216 17.568h1v1h-1z"></path><path fill="currentColor" d="M4.919 17.568h1v1h-1zM6.324 17.568h1v1h-1z"></path><path fill="currentColor" d="M7.027 17.568h1v1h-1zM8.432 17.568h1v1h-1zM10.54 17.568h1v1h-1zM13.351 17.568h1v1h-1z"></path><path fill="currentColor" d="M14.054 17.568h1v1h-1z"></path><path fill="currentColor" d="M14.757 17.568h1v1h-1z"></path><path fill="currentColor" d="M15.46 17.568h1v1h-1z"></path><path fill="currentColor" d="M16.162 17.568h1v1h-1z"></path><path fill="currentColor" d="M16.865 17.568h1v1h-1zM18.973 17.568h1v1h-1z"></path><path fill="currentColor" d="M19.676 17.568h1v1h-1zM21.081 17.568h1v1h-1z"></path><path fill="currentColor" d="M21.784 17.568h1v1h-1zM23.19 17.568h1v1h-1z"></path><path fill="currentColor" d="M23.892 17.568h1v1h-1zM1.405 18.27h1v1h-1z"></path><path fill="currentColor" d="M2.108 18.27h1v1h-1z"></path><path fill="currentColor" d="M2.81 18.27h1v1h-1zM4.216 18.27h1v1h-1zM5.622 18.27h1v1h-1z"></path><path fill="currentColor" d="M6.324 18.27h1v1h-1zM8.432 18.27h1v1h-1z"></path><path fill="currentColor" d="M9.135 18.27h1v1h-1zM10.54 18.27h1v1h-1z"></path><path fill="currentColor" d="M11.243 18.27h1v1h-1z"></path><path fill="currentColor" d="M11.946 18.27h1v1h-1z"></path><path fill="currentColor" d="M12.649 18.27h1v1h-1z"></path><path fill="currentColor" d="M13.351 18.27h1v1h-1zM15.46 18.27h1v1h-1z"></path><path fill="currentColor" d="M16.162 18.27h1v1h-1z"></path><path fill="currentColor" d="M16.865 18.27h1v1h-1zM18.27 18.27h1v1h-1z"></path><path fill="currentColor" d="M18.973 18.27h1v1h-1z"></path><path fill="currentColor" d="M19.676 18.27h1v1h-1z"></path><path fill="currentColor" d="M20.378 18.27h1v1h-1z"></path><path fill="currentColor" d="M21.081 18.27h1v1h-1z"></path><path fill="currentColor" d="M21.784 18.27h1v1h-1zM23.19 18.27h1v1h-1zM7.027 18.973h1v1h-1zM8.432 18.973h1v1h-1z"></path><path fill="currentColor" d="M9.135 18.973h1v1h-1zM10.54 18.973h1v1h-1z"></path><path fill="currentColor" d="M11.243 18.973h1v1h-1z"></path><path fill="currentColor" d="M11.946 18.973h1v1h-1z"></path><path fill="currentColor" d="M12.649 18.973h1v1h-1z"></path><path fill="currentColor" d="M13.351 18.973h1v1h-1zM16.162 18.973h1v1h-1z"></path><path fill="currentColor" d="M16.865 18.973h1v1h-1z"></path><path fill="currentColor" d="M17.568 18.973h1v1h-1z"></path><path fill="currentColor" d="M18.27 18.973h1v1h-1zM21.081 18.973h1v1h-1zM22.487 18.973h1v1h-1zM7.027 19.676h1v1h-1z"></path><path fill="currentColor" d="M7.73 19.676h1v1h-1z"></path><path fill="currentColor" d="M8.432 19.676h1v1h-1zM11.243 19.676h1v1h-1z"></path><path fill="currentColor" d="M11.946 19.676h1v1h-1zM14.054 19.676h1v1h-1zM18.27 19.676h1v1h-1zM19.676 19.676h1v1h-1zM21.081 19.676h1v1h-1z"></path><path fill="currentColor" d="M21.784 19.676h1v1h-1zM9.135 20.378h1v1h-1zM11.243 20.378h1v1h-1z"></path><path fill="currentColor" d="M11.946 20.378h1v1h-1z"></path><path fill="currentColor" d="M12.649 20.378h1v1h-1zM14.757 20.378h1v1h-1zM16.865 20.378h1v1h-1zM18.27 20.378h1v1h-1zM21.081 20.378h1v1h-1zM23.892 20.378h1v1h-1zM7.027 21.081h1v1h-1zM9.135 21.081h1v1h-1z"></path><path fill="currentColor" d="M9.838 21.081h1v1h-1z"></path><path fill="currentColor" d="M10.54 21.081h1v1h-1z"></path><path fill="currentColor" d="M11.243 21.081h1v1h-1zM12.649 21.081h1v1h-1zM14.757 21.081h1v1h-1zM16.865 21.081h1v1h-1zM18.27 21.081h1v1h-1z"></path><path fill="currentColor" d="M18.973 21.081h1v1h-1z"></path><path fill="currentColor" d="M19.676 21.081h1v1h-1z"></path><path fill="currentColor" d="M20.378 21.081h1v1h-1z"></path><path fill="currentColor" d="M21.081 21.081h1v1h-1z"></path><path fill="currentColor" d="M21.784 21.081h1v1h-1zM23.892 21.081h1v1h-1zM7.73 21.784h1v1h-1z"></path><path fill="currentColor" d="M8.432 21.784h1v1h-1zM9.838 21.784h1v1h-1z"></path><path fill="currentColor" d="M10.54 21.784h1v1h-1zM14.054 21.784h1v1h-1z"></path><path fill="currentColor" d="M14.757 21.784h1v1h-1z"></path><path fill="currentColor" d="M15.46 21.784h1v1h-1zM17.568 21.784h1v1h-1zM19.676 21.784h1v1h-1z"></path><path fill="currentColor" d="M20.378 21.784h1v1h-1z"></path><path fill="currentColor" d="M21.081 21.784h1v1h-1z"></path><path fill="currentColor" d="M21.784 21.784h1v1h-1z"></path><path fill="currentColor" d="M22.487 21.784h1v1h-1z"></path><path fill="currentColor" d="M23.19 21.784h1v1h-1zM7.73 22.487h1v1h-1zM9.838 22.487h1v1h-1zM11.243 22.487h1v1h-1z"></path><path fill="currentColor" d="M11.946 22.487h1v1h-1zM14.054 22.487h1v1h-1zM15.46 22.487h1v1h-1z"></path><path fill="currentColor" d="M16.162 22.487h1v1h-1zM18.973 22.487h1v1h-1z"></path><path fill="currentColor" d="M19.676 22.487h1v1h-1z"></path><path fill="currentColor" d="M20.378 22.487h1v1h-1z"></path><path fill="currentColor" d="M21.081 22.487h1v1h-1z"></path><path fill="currentColor" d="M21.784 22.487h1v1h-1zM9.135 23.19h1v1h-1z"></path><path fill="currentColor" d="M9.838 23.19h1v1h-1z"></path><path fill="currentColor" d="M10.54 23.19h1v1h-1zM11.946 23.19h1v1h-1z"></path><path fill="currentColor" d="M12.649 23.19h1v1h-1z"></path><path fill="currentColor" d="M13.351 23.19h1v1h-1z"></path><path fill="currentColor" d="M14.054 23.19h1v1h-1zM16.162 23.19h1v1h-1zM17.568 23.19h1v1h-1z"></path><path fill="currentColor" d="M18.27 23.19h1v1h-1zM19.676 23.19h1v1h-1zM7.027 23.892h1v1h-1zM8.432 23.892h1v1h-1zM13.351 23.892h1v1h-1zM14.757 23.892h1v1h-1z"></path><path fill="currentColor" d="M15.46 23.892h1v1h-1z"></path><path fill="currentColor" d="M16.162 23.892h1v1h-1z"></path><path fill="currentColor" d="M16.865 23.892h1v1h-1z"></path><path fill="currentColor" d="M17.568 23.892h1v1h-1z"></path><path fill="currentColor" d="M18.27 23.892h1v1h-1z"></path><path fill="currentColor" d="M18.973 23.892h1v1h-1z"></path><path fill="currentColor" d="M19.676 23.892h1v1h-1zM21.784 23.892h1v1h-1zM23.892 23.892h1v1h-1z"></path><path d="M2.143 2.143h3.443v3.443H2.143z"></path><path fill="currentColor" fill-rule="nonzero" d="M5.586 1.405H1.405v4.919h4.919V1.405zm0 4.181H2.143V2.143h3.443z"></path><path d="M20.414 2.143h3.443v3.443h-3.443z"></path><path fill="currentColor" fill-rule="nonzero" d="M23.857 1.405h-4.181v4.919h4.919V1.405zm0 4.181h-3.443V2.143h3.443z"></path><path d="M2.143 20.414h3.443v3.443H2.143z"></path><path fill="currentColor" fill-rule="nonzero" d="M5.586 19.676H1.405v4.919h4.919v-4.919zm0 4.18H2.143v-3.442h3.443z"></path><path fill="currentColor" d="M2.81 2.81H4.92V4.92H2.81zM21.081 2.81h2.108V4.92h-2.108zM2.81 21.081H4.92v2.108H2.81z"></path></g>', 1)
  ])]);
}
const dn = { render: ro }, no = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function so(n, t) {
  return e(), r("svg", no, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M21.806 16.572A9.322 9.322 0 1 1 9.903 5.227c1.751-.577 3.688-.668 5.426-.247" }),
      o("path", { d: "M11.893.903 15.33 4.98l-4.078 3.436" })
    ], -1)
  ])]);
}
const xn = { render: so }, lo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function io(n, t) {
  return e(), r("svg", lo, [...t[0] || (t[0] = [
    s('<g fill="none" fill-rule="evenodd"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2 2v7.5h7.5" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"></path><path fill="currentColor" d="M13.263 1.2c5.386.003 9.94 3.554 11.457 8.44-.25-.09-.521-.14-.81-.14h-.824c-1.496-3.971-5.329-6.797-9.824-6.8a10.5 10.5 0 0 0-9.905 7 .75.75 0 0 1-1.414-.5 12 12 0 0 1 11.32-8"></path><path fill="currentColor" d="M5.876 20.625a10.45 10.45 0 0 0 5.625 2.925c.016.565.16 1.11.41 1.573a11.94 11.94 0 0 1-7.096-3.438.75.75 0 0 1 1.061-1.06m15.92-15.9a11.95 11.95 0 0 1 2.976 4.937 2.3 2.3 0 0 0-.863-.162h-.777a10.5 10.5 0 0 0-2.398-3.716A10.5 10.5 0 0 0 8.78 3.73a.75.75 0 0 1-.647-1.354 12 12 0 0 1 13.662 2.349"></path><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"><path fill="currentColor" d="M14.91 15h8.18c.503 0 .91.448.91 1v7c0 .552-.407 1-.91 1h-8.18c-.503 0-.91-.448-.91-1v-7c0-.552.407-1 .91-1"></path><path d="M16 15v-2.083C16 11.307 17.343 10 19 10s3 1.306 3 2.917V15"></path></g></g>', 1)
  ])]);
}
const wn = { render: io }, co = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function ao(n, t) {
  return e(), r("svg", co, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M8.5 15 2 8.5 8.54 2" }),
      o("path", {
        "stroke-linecap": "round",
        d: "M11 23.5h6a7.5 7.5 0 0 0 0-15H2"
      })
    ], -1)
  ])]);
}
const vn = { render: ao }, ho = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function po(n, t) {
  return e(), r("svg", ho, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M2.724 14.61a9.063 9.063 0 1 0 16.681-7.09 9.063 9.063 0 0 0-16.68 7.09ZM17.473 17.473l7.029 7.03" })
    ], -1)
  ])]);
}
const un = { render: po }, xo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function wo(n, t) {
  return e(), r("svg", xo, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M15.75 7.5h-3.727a2.46 2.46 0 0 0-.917 4.743l3.784 1.514a2.46 2.46 0 0 1-.917 4.743H10.25M13 7.5V6.125M13 19.875V18.5" }),
      o("path", { d: "M2 13c0 6.076 4.924 11 11 11s11-4.924 11-11S19.076 2 13 2 2 6.924 2 13Z" })
    ], -1)
  ])]);
}
const kn = { render: wo }, vo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function uo(n, t) {
  return e(), r("svg", vo, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M3.083 11.424a1.487 1.487 0 0 1-.069-2.84l20.071-6.547a.751.751 0 0 1 .948.943l-6.54 20.081a1.486 1.486 0 0 1-2.842-.07l-2.246-9.33zM23.848 2.217 12.405 13.66" })
    ], -1)
  ])]);
}
const Mn = { render: uo }, ko = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Mo(n, t) {
  return e(), r("svg", ko, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "square",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M18.5 9.5H20a1.5 1.5 0 0 1 1.5 1.5v12a1.5 1.5 0 0 1-1.5 1.5H6.5A1.5 1.5 0 0 1 5 23V11a1.5 1.5 0 0 1 1.5-1.5H8M13.25 3.001V12.5M9.5 5.75 13.25 2 17 5.75" })
    ], -1)
  ])]);
}
const fn = { render: Mo }, fo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function go(n, t) {
  return e(), r("svg", fo, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M3 5.174v7.614A11.9 11.9 0 0 0 10.632 23.9l1.041.4a3 3 0 0 0 2.154 0l1.041-.4A11.91 11.91 0 0 0 22.5 12.788V5.174a1.49 1.49 0 0 0-.868-1.362A21.7 21.7 0 0 0 12.75 2a21.7 21.7 0 0 0-8.882 1.81A1.48 1.48 0 0 0 3 5.175"
      }),
      o("path", { d: "M12.75 17.5a.375.375 0 0 1 0-.75M12.75 17.5a.375.375 0 0 0 0-.75" }),
      o("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M12.75 13.501v-5.5"
      })
    ], -1)
  ])]);
}
const gn = { render: go }, zo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function _o(n, t) {
  return e(), r("svg", zo, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M1 13.002h15.75M13 16.752l3.75-3.75L13 9.252" }),
      o("path", { d: "M3.556 17.598c2.538 5.214 8.822 7.383 14.036 4.845s7.384-8.822 4.846-14.036-8.823-7.384-14.037-4.845a10.5 10.5 0 0 0-4.666 4.494" })
    ], -1)
  ])]);
}
const zn = { render: _o }, mo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  style: { "container-type": "size", "aspect-ratio": "16/16", "--icon-vw": "16px", "--icon-vh": "16px" }
};
function yo(n, t) {
  return e(), r("svg", mo, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(16px/100cqw,16px/100cqh))" }
    }, [
      o("path", { d: "M8.154 1.23a6.923 6.923 0 1 1 0 13.847 6.923 6.923 0 0 1 0-13.846" }),
      o("path", { d: "M7.459 14.954c-1.39-1.354-2-3.896-2-6.77s.61-5.476 2-6.8M8.816 14.954c1.423-1.354 2-3.896 2-6.77s-.577-5.476-2-6.8M1.23 8.154h13.847" })
    ], -1)
  ])]);
}
const _n = { render: yo }, Co = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  style: { "container-type": "size", "aspect-ratio": "16/16", "--icon-vw": "16px", "--icon-vh": "16px" }
};
function qo(n, t) {
  return e(), r("svg", Co, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(16px/100cqw,16px/100cqh))" }
    }, [
      o("path", { d: "M6.77 1.23h7.076c.34 0 .616.276.616.616V14.77c0 .17-.138.308-.308.308H6.462a.31.31 0 0 1-.308-.308V1.846c0-.34.276-.615.615-.615M6.154 8.615v6.154c0 .17-.138.308-.308.308H2.154a.31.31 0 0 1-.308-.308V8.615c0-.17.138-.307.308-.307h3.692c.17 0 .308.138.308.307M10.423 7.8v1.067M10.423 4v1.067" }),
      o("path", { d: "M10.375 12.082c-.345 0-.625.302-.625.674v1.526H11v-1.526c0-.372-.28-.674-.625-.674" })
    ], -1)
  ])]);
}
const mn = { render: qo }, $o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Bo(n, t) {
  return e(), r("svg", $o, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "square",
      "stroke-width": "1.682",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.682px", "stroke-width": "calc(1.682px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M8.091 6.612v12.777M4 9.667 8.09 5.5l4.092 4.167M17.909 19.388V6.611M22 16.333 17.91 20.5l-4.092-4.167" })
    ], -1)
  ])]);
}
const yn = { render: Bo }, Io = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 28",
  style: { "container-type": "size", "aspect-ratio": "26/28", "--icon-vw": "26px", "--icon-vh": "28px" }
};
function Vo(n, t) {
  return e(), r("svg", Io, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,28px/100cqh))" }
    }, [
      o("path", { d: "M3.093 13.99h19.866M2 14.01c8.128 0 10.982-7.359 10.982-7.359l1.621-3.805" }),
      o("path", { d: "M2 13.99c8.128 0 10.982 7.359 10.982 7.359l1.621 3.67M20.5 11l3 3-3 3M10.647 4.092l3.987-1.451 1.451 3.986" }),
      o("path", { d: "m16.085 21.373-1.451 3.986-3.987-1.45" })
    ], -1)
  ])]);
}
const Cn = { render: Vo }, Ho = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Ao(n, t) {
  return e(), r("svg", Ho, [...t[0] || (t[0] = [
    o("defs", null, [
      o("path", {
        id: "strings_svg__a",
        d: "M3.75 1.5a26.75 26.75 0 0 0 16.069.527 1.5 1.5 0 0 1 1.855 1.567c-.645 8.8-5.427 15.648-14.347 19.419a3 3 0 0 1-1.167.237H.75V.75h3Z"
      })
    ], -1),
    o("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M2.75 24.25h3V1.75h-3zM5.75 2.5a26.75 26.75 0 0 0 16.069.527 1.5 1.5 0 0 1 1.855 1.567c-.645 8.8-5.427 15.648-14.347 19.419a3 3 0 0 1-1.167.237H5.75" }),
      o("path", { d: "M5.75 6.25a16.68 16.68 0 0 0 11.671.832 1.5 1.5 0 0 1 1.793 1.952 19.96 19.96 0 0 1-9.772 11.1 3 3 0 0 1-1.428.366H5.75M8.75 7.31v13.098M11.75 7.734v10.99M14.75 7.605v8.607" })
    ], -1)
  ])]);
}
const qn = { render: Ao }, jo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Lo(n, t) {
  return e(), r("svg", jo, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", {
        "stroke-linecap": "round",
        d: "M13 24.25c6.213 0 11.25-5.037 11.25-11.25S19.213 1.75 13 1.75 1.75 6.787 1.75 13 6.787 24.25 13 24.25"
      }),
      o("path", { d: "M17.665 8.948A6.05 6.05 0 0 0 6.95 12.796v1.652M8.6 16.948a6.05 6.05 0 0 0 10.45-4.152v-1.1" }),
      o("path", {
        "stroke-linecap": "square",
        d: "m4.75 12.246 2.2 2.2 2.2-2.2M21.25 13.896l-2.2-2.2-2.2 2.2"
      })
    ], -1)
  ])]);
}
const $n = { render: Lo }, Fo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function bo(n, t) {
  return e(), r("svg", Fo, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M19.503 7.59A8.386 8.386 0 0 0 7.631 6.446a8.53 8.53 0 0 0-3.064 6.552v2.322M6.867 18.833a8.384 8.384 0 0 0 11.92.348 8.54 8.54 0 0 0 2.646-6.183v-1.546" }),
      o("path", {
        "stroke-linecap": "square",
        d: "m1.5 12.225 3.067 3.092 3.066-3.092M24.5 14.544l-3.067-3.092-3.066 3.092"
      })
    ], -1)
  ])]);
}
const Bn = { render: bo }, So = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Do(n, t) {
  return e(), r("svg", So, [...t[0] || (t[0] = [
    o("defs", null, [
      o("path", {
        id: "synthesizer_svg__a",
        d: "M20.232 2.25h1.518a1.5 1.5 0 0 1 1.5 1.5v14a1.5 1.5 0 0 1-1.5 1.5H2.25a1.5 1.5 0 0 1-1.5-1.5v-14a1.5 1.5 0 0 1 1.5-1.5h1.518a1.75 1.75 0 0 1 3.464 0h3.036a1.75 1.75 0 0 1 3.464 0h3.036a1.75 1.75 0 0 1 3.464 0"
      })
    ], -1),
    o("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M4.77 5.25H3.25a1.5 1.5 0 0 0-1.5 1.5v14a1.5 1.5 0 0 0 1.5 1.5h19.5a1.5 1.5 0 0 0 1.5-1.5v-14a1.5 1.5 0 0 0-1.5-1.5h-1.52" }),
      o("path", { d: "M8.25 12.25a1.75 1.75 0 0 1-3.5 0V5.5a1.75 1.75 0 1 1 3.5 0zM14.75 12.25a1.75 1.75 0 0 1-3.5 0V5.5a1.75 1.75 0 1 1 3.5 0zM21.25 12.25a1.75 1.75 0 0 1-3.5 0V5.5a1.75 1.75 0 1 1 3.5 0zM6.5 14v8.25M13 14v8.25M19.5 14v8.25M8.25 5.25h3M14.73 5.25h3.04" })
    ], -1)
  ])]);
}
const In = { render: Do }, Zo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Eo(n, t) {
  return e(), r("svg", Zo, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M1.875 7.62v11.25a3 3 0 0 0 3 3h16.5a3 3 0 0 0 3-3V7.62a3 3 0 0 0-3-3h-16.5a3 3 0 0 0-3 3"
      }),
      o("path", { d: "M4.9 13.25a.25.25 0 0 1-.5 0M4.9 13.25a.25.25 0 0 0-.5 0" })
    ], -1)
  ])]);
}
const Vn = { render: Eo }, Go = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Oo(n, t) {
  return e(), r("svg", Go, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M20.119 11.907a1.757 1.757 0 1 1 0 3.515 1.757 1.757 0 0 1 0-3.515M22.989 17.614a3.627 3.627 0 0 0-5.732 0M5.881 11.907a1.757 1.757 0 1 1 0 3.515 1.757 1.757 0 0 1 0-3.515M3.01 17.613a3.627 3.627 0 0 1 5.73-.008" }),
      o("path", { d: "M17.481 19a4.48 4.48 0 0 0-4.482-4.48A4.48 4.48 0 0 0 8.519 19M12.954 8a2.649 2.649 0 1 1-.001 5.297A2.649 2.649 0 0 1 12.954 8" }),
      o("path", { d: "M13 1.75c6.213 0 11.25 5.037 11.25 11.25S19.213 24.25 13 24.25 1.75 19.213 1.75 13 6.787 1.75 13 1.75" })
    ], -1)
  ])]);
}
const Hn = { render: Oo }, Po = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Ro(n, t) {
  return e(), r("svg", Po, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "square",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M1.75 19.75h11.5M1.75 14.75h22.5M1.75 9.75h22.5M1.75 4.75h22.5" })
    ], -1)
  ])]);
}
const An = { render: Ro }, Wo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Uo(n, t) {
  return e(), r("svg", Wo, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M6.605 10.533c3.893-.3 5.141-2.967 5.932-6.915 0-1.56 4.483-1.766 4.483 1.199-.15 1.959-.51 2.916-1.07 4.8h6.086a1.962 1.962 0 0 1 1.904 2.444l-1.963 8.835a1.964 1.964 0 0 1-1.904 1.492H6.605M3.497 9.52h3.108v12.868H3.497c-.827 0-1.497-.67-1.497-1.497v-9.875c0-.827.67-1.497 1.497-1.497" })
    ], -1)
  ])]);
}
const jn = { render: Uo }, No = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function To(n, t) {
  return e(), r("svg", No, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M19.333 24H6.5a1.834 1.834 0 0 1-1.833-1.833v-16.5h16.5v16.5A1.834 1.834 0 0 1 19.333 24M10.167 18.5v-7.333M15.667 18.5v-7.333M1 5.667h23.833M15.667 2h-5.5a1.834 1.834 0 0 0-1.834 1.833v1.834H17.5V3.833A1.834 1.834 0 0 0 15.667 2" })
    ], -1)
  ])]);
}
const Ln = { render: To }, Qo = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 26 26"
};
function Jo(n, t) {
  return e(), r("svg", Qo, [...t[0] || (t[0] = [
    s('<defs><path id="twitter_svg__a" d="M0 0h24v19.414H0z"></path></defs><g fill="none" fill-rule="evenodd" transform="translate(1 3)"><mask id="twitter_svg__b" fill="#fff"><use xlink:href="#twitter_svg__a"></use></mask><path fill="currentColor" d="M24 2.326a9.9 9.9 0 0 1-2.827.773A4.92 4.92 0 0 0 23.338.39a9.9 9.9 0 0 1-3.125 1.172 4.92 4.92 0 0 0-8.39 4.464A14.01 14.01 0 0 1 1.67.924a4.88 4.88 0 0 0 1.527 6.533A4.9 4.9 0 0 1 .96 6.843v.062a4.906 4.906 0 0 0 3.95 4.8 4.96 4.96 0 0 1-2.222.086 4.925 4.925 0 0 0 4.598 3.399A9.92 9.92 0 0 1 0 17.215a14 14 0 0 0 7.55 2.199c9.058 0 14.012-7.46 14.012-13.92V4.86A10 10 0 0 0 24 2.326" mask="url(#twitter_svg__b)"></path></g>', 2)
  ])]);
}
const Fn = { render: Jo }, Ko = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Xo(n, t) {
  return e(), r("svg", Ko, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M3.467 7.867h19.066c.81 0 1.467.657 1.467 1.466v7.334c0 .81-.657 1.466-1.467 1.466H3.467c-.81 0-1.467-.657-1.467-1.466V9.333c0-.81.657-1.466 1.467-1.466M18.133 19.6V6.4M13.733 24a4.4 4.4 0 0 0 4.4-4.4 4.4 4.4 0 0 0 4.4 4.4M13.733 2a4.4 4.4 0 0 1 4.4 4.4 4.4 4.4 0 0 1 4.4-4.4" })
    ], -1)
  ])]);
}
const bn = { render: Xo }, Yo = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function te(n, t) {
  return e(), r("svg", Yo, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M11.848 8H6.623a4.623 4.623 0 0 0 0 9.246h5.225M14.152 17.246h5.225a4.623 4.623 0 0 0 0-9.246h-5.225M8.391 12.623h9.218" })
    ], -1)
  ])]);
}
const Sn = { render: te }, oe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function ee(n, t) {
  return e(), r("svg", oe, [...t[0] || (t[0] = [
    s('<g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-width="1.5" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"><path d="M12.96 24V10"></path><path stroke-linecap="square" stroke-linejoin="round" d="m19.96 16.98-7-7-7 7"></path><g stroke-linecap="round" stroke-linejoin="round"><path d="M13 1.5v2.292M4.559 5.011l2.04 1.696M21.441 5.011l-2.04 1.696"></path></g></g>', 1)
  ])]);
}
const Dn = { render: ee }, re = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function ne(n, t) {
  return e(), r("svg", re, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M13 18.335V2" }),
      o("path", {
        "stroke-linecap": "square",
        d: "m19 8-6-6-6 6M24 23H2"
      })
    ], -1)
  ])]);
}
const Zn = { render: ne }, se = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 26 26"
};
function le(n, t) {
  return e(), r("svg", se, [...t[0] || (t[0] = [
    s('<defs><path id="verified-default_svg__a" d="M0 0h23.778v25H0z"></path></defs><g fill="none" fill-rule="evenodd" transform="translate(1.1 1)"><mask id="verified-default_svg__b" fill="#fff"><use xlink:href="#verified-default_svg__a"></use></mask><path fill="#04A9BA" d="M10.952 16.319a.896.896 0 0 1-1.27 0l-3.223-3.223 1.27-1.27 2.589 2.588 5.731-5.732 1.27 1.27zM23.778 8.65 20.07 6.568l-.826-4.172-4.224.498L11.9 0 8.777 2.888l-4.226-.507-.83 4.172L.008 8.626l1.777 3.864L0 16.35l3.707 2.083.826 4.172 4.225-.498L11.876 25l3.126-2.889 4.225.51.83-4.173 3.714-2.073-1.776-3.864z" mask="url(#verified-default_svg__b)"></path></g>', 2)
  ])]);
}
const En = { render: le }, ie = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function ce(n, t) {
  return e(), r("svg", ie, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", {
        "stroke-linecap": "round",
        d: "M5 6h9a3 3 0 0 1 3 3v7.5a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3"
      }),
      o("path", {
        "stroke-linecap": "square",
        d: "m20 15.75 3.415 1.707a.75.75 0 0 0 1.085-.671V8.713a.75.75 0 0 0-1.085-.67L20 9.75"
      })
    ], -1)
  ])]);
}
const Gn = { render: ce }, ae = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function he(n, t) {
  return e(), r("svg", ae, [...t[0] || (t[0] = [
    o("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M5.778 3.446c0-.63.535-.674.985-.387l14.438 9.205c.491.313.491 1.186 0 1.5L6.763 22.969c-.45.287-.985.145-.985-.485V3.446Z",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, null, -1)
  ])]);
}
const On = { render: he }, pe = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 40 26",
  style: { "container-type": "size", "aspect-ratio": "40/26", "--icon-vw": "40px", "--icon-vh": "26px" }
};
function de(n, t) {
  return e(), r("svg", pe, [...t[0] || (t[0] = [
    s('<defs><path id="visa_svg__a" d="M0 0h30.863v10H0z"></path></defs><g fill="none" fill-rule="evenodd"><rect width="39" height="25" x=".5" y=".5" fill="#F6F6F6" stroke="#424446" stroke-opacity=".25" rx="4" data-icon-stroke="" style="--icon-sw:1px;stroke-width:calc(1px*max(40px/100cqw,26px/100cqh));"></rect><g transform="translate(5 8)"><mask id="visa_svg__b" fill="#fff"><use xlink:href="#visa_svg__a"></use></mask><path fill="#1434CB" d="m27.075 2.771.778 3.635H25.77zm-.34-2.617c-.604 0-.924.323-1.159.888L21.91 9.841h2.624l.508-1.467h3.197l.309 1.467h2.315L28.843.154zm-13.958 0L10.72 9.841h2.502L15.273.154zM.053.154 0 .464s.922.168 1.752.504c1.07.386 1.146.611 1.326 1.309L5.04 9.84h2.63L11.722.154H9.098L6.494 6.74 5.432 1.158C5.334.518 4.84.154 4.237.154zM20.103 0c-2.192 0-4.15 1.136-4.15 3.234 0 2.407 3.473 2.573 3.473 3.782 0 .51-.583.965-1.58.965-1.414 0-2.471-.637-2.471-.637l-.452 2.118S16.14 10 17.757 10c2.396 0 4.281-1.192 4.281-3.326 0-2.543-3.488-2.704-3.488-3.827 0-.398.48-.835 1.473-.835 1.121 0 2.036.463 2.036.463L22.5.429S21.506 0 20.103 0" mask="url(#visa_svg__b)"></path></g></g>', 2)
  ])]);
}
const Pn = { render: de }, xe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function we(n, t) {
  return e(), r("svg", xe, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "square",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M3.5 9.5v7M12.5 9.5v7M22.5 9.5v7M17.5 6.25v13.5M8 1.75v22.5" })
    ], -1)
  ])]);
}
const Rn = { render: we }, ve = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function ue(n, t) {
  return e(), r("svg", ve, [...t[0] || (t[0] = [
    o("defs", null, [
      o("path", {
        id: "voice-and-noise_svg__a",
        d: "M12.902 4.734V8.52h4.184a8.169 8.169 0 0 1-16.336 0h4.183V4.734A3.984 3.984 0 0 1 8.72.755l.2-.005c2.2 0 3.983 1.783 3.983 3.984"
      })
    ], -1),
    o("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M7.938 23.664h9.961M12.918 17.688v5.977M21.086 9.52a8.169 8.169 0 0 1-16.336 0" }),
      o("path", { d: "M16.902 5.734a3.984 3.984 0 1 0-7.969 0v3.984a3.985 3.985 0 1 0 7.97 0zM8.934 9.002h7.969" })
    ], -1)
  ])]);
}
const Wn = { render: ue }, ke = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26.4"
};
function Me(n, t) {
  return e(), r("svg", ke, [...t[0] || (t[0] = [
    o("defs", null, [
      o("path", {
        id: "volume-high_svg__a",
        d: "M13 4.726v16.96c0 .816-.857 1.223-1.524.816l-5.428-5.223H1.952c-.57 0-.952-.407-.952-1.018v-6.109c0-.61.381-1.018.952-1.018h4.096l5.428-5.222c.667-.509 1.524 0 1.524.814m8.8.742c2 2.03 3.2 4.738 3.2 7.717s-1.2 5.686-3.2 7.717c-.267.27-.533.406-.933.406a1.43 1.43 0 0 1-.934-.406 1.323 1.323 0 0 1 0-1.896c1.6-1.624 2.4-3.655 2.4-5.821s-.8-4.197-2.4-5.822a1.323 1.323 0 0 1 0-1.895c.534-.542 1.334-.542 1.867 0M17.797 8.15c1.604 1.629 1.96 3 2.03 4.343q.015.345.014.69c0 1.571-.477 3.7-2.044 5.15a.9.9 0 0 1-.397.21c-.51.144-1.164-.014-1.357-.21a1.24 1.24 0 0 1 0-1.782c.76-.772 1.326-2.1 1.326-3.367 0-1.278-.346-2.257-1.326-3.252a1.24 1.24 0 0 1 0-1.782 1.205 1.205 0 0 1 1.754 0"
      })
    ], -1),
    o("g", {
      fill: "currentColor",
      "fill-rule": "evenodd"
    }, [
      o("path", { d: "M21.8 5.468c-.533-.542-1.333-.542-1.867 0a1.323 1.323 0 0 0 0 1.895c1.6 1.625 2.4 3.655 2.4 5.822 0 2.166-.8 4.197-2.4 5.821a1.323 1.323 0 0 0 0 1.896c.267.27.667.406.934.406.4 0 .666-.136.933-.406 2-2.031 3.2-4.739 3.2-7.717 0-2.979-1.2-5.687-3.2-7.717" }),
      o("path", {
        "fill-rule": "nonzero",
        d: "M1.952 9.134h4.096l5.428-5.222c.667-.509 1.524 0 1.524.814v16.96c0 .816-.857 1.223-1.524.816l-5.428-5.223H1.952c-.57 0-.952-.407-.952-1.018v-6.109c0-.61.381-1.018.952-1.018m14.09.799a1.24 1.24 0 0 1 0-1.782 1.205 1.205 0 0 1 1.755 0c1.604 1.629 1.96 3 2.03 4.343q.015.345.014.69c0 1.571-.477 3.7-2.044 5.15a.9.9 0 0 1-.397.21c-.51.144-1.164-.014-1.357-.21a1.24 1.24 0 0 1 0-1.782c.76-.772 1.326-2.1 1.326-3.367 0-1.278-.346-2.257-1.326-3.252"
      })
    ], -1)
  ])]);
}
const Un = { render: Me }, fe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function ge(n, t) {
  return e(), r("svg", fe, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      d: "M1.952 9.134h4.096l5.428-5.222c.667-.509 1.524 0 1.524.814v16.96c0 .816-.857 1.223-1.524.816l-5.428-5.223H1.952c-.57 0-.952-.407-.952-1.018v-6.109c0-.61.381-1.018.952-1.018m14.09.799a1.24 1.24 0 0 1 0-1.782 1.205 1.205 0 0 1 1.755 0c1.604 1.629 1.96 3 2.03 4.343q.015.345.014.69c0 1.571-.477 3.7-2.044 5.15a.9.9 0 0 1-.397.21c-.51.144-1.164-.014-1.357-.21a1.24 1.24 0 0 1 0-1.782c.76-.772 1.326-2.1 1.326-3.367 0-1.278-.346-2.257-1.326-3.252"
    }, null, -1)
  ])]);
}
const Nn = { render: ge }, ze = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function _e(n, t) {
  return e(), r("svg", ze, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      d: "M1.952 9.15h4.096l5.428-5.222c.667-.51 1.524 0 1.524.813v16.961c0 .815-.857 1.223-1.524.815l-5.428-5.223H1.952c-.57 0-.952-.406-.952-1.018v-6.109c0-.61.381-1.018.952-1.018m18.381 2.137-2.357-2.394a1.32 1.32 0 0 0-1.297-.37c-.466.125-.83.494-.952.968-.122.473.017.976.364 1.316l2.356 2.394-2.356 2.394a1.37 1.37 0 0 0 .016 1.897c.514.523 1.346.53 1.869.017l2.357-2.394 2.358 2.394a1.32 1.32 0 0 0 1.869-.017 1.37 1.37 0 0 0 .016-1.897L22.219 13.2l2.357-2.394a1.37 1.37 0 0 0-.016-1.897 1.32 1.32 0 0 0-1.87-.017z"
    }, null, -1)
  ])]);
}
const Tn = { render: _e }, me = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function ye(n, t) {
  return e(), r("svg", me, [...t[0] || (t[0] = [
    o("defs", null, [
      o("path", {
        id: "wind_svg__a",
        d: "M16.5 8.25a3 3 0 0 1-3 3H6.75a3 3 0 1 1 0-6h6.75a3 3 0 0 1 3 3m6.75 1.5-3.75-4.5 3.75-4.5Z"
      })
    ], -1),
    o("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "M1.75 11.25H20.5M20.5 11.25l3.75 4.5v-9zM9.25 8.25v12M12.25 8.25v12M1.75 9.75v3M7.75 11.25h6.75a3 3 0 1 1 0 6H7.75a3 3 0 1 1 0-6" })
    ], -1)
  ])]);
}
const Qn = { render: ye }, Ce = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function qe(n, t) {
  return e(), r("svg", Ce, [...t[0] || (t[0] = [
    o("path", {
      fill: "#0078D4",
      "fill-rule": "evenodd",
      d: "M13.57 12.425H24V2H13.57zm-11.57 0h10.43V2H2zM13.57 24H24V13.57H13.57zM2 24h10.43V13.57H2z"
    }, null, -1)
  ])]);
}
const Jn = { render: qe }, $e = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Be(n, t) {
  return e(), r("svg", $e, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("path", { d: "m14.856 24.194-3.7-7.89 5.002-2.232 4.512 9.553" }),
      o("path", { d: "m11.156 16.304 5.002-2.231-.171-5.424a1.83 1.83 0 0 0-.722-1.62L8.164 1.898a.457.457 0 0 0-.73.325l-.927 8.71a1.83 1.83 0 0 0 .726 1.622zM7.704 1.846l3.545 7.946M17.702 17.955l-3.979 1.744" })
    ], -1)
  ])]);
}
const Kn = { render: Be }, Ie = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function Ve(n, t) {
  return e(), r("svg", Ie, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m20.963 2.25-6.788 7.89-5.422-7.89H2.5l8.199 11.932-8.199 9.53h1.853l7.168-8.333 5.726 8.332H23.5l-8.503-12.374 7.819-9.087zM12.46 14.287l-.83-1.188-6.61-9.454h2.846l5.334 7.63.83 1.188 6.934 9.917h-2.846z"
    }, null, -1)
  ])]);
}
const Xn = { render: Ve }, He = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function Ae(n, t) {
  return e(), r("svg", He, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linejoin": "round"
    }, [
      o("path", {
        fill: "#F2C2C3",
        stroke: "#F2C2C3",
        "stroke-linecap": "round",
        "stroke-width": "1.5",
        d: "M13 24.25c6.213 0 11.25-5.037 11.25-11.25S19.213 1.75 13 1.75 1.75 6.787 1.75 13 6.787 24.25 13 24.25",
        opacity: ".5",
        "data-icon-stroke": "",
        style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
      }),
      o("g", {
        stroke: "#A31A2C",
        "stroke-width": "2",
        "data-icon-stroke": "",
        style: { "--icon-sw": "2px", "stroke-width": "calc(2px*max(26px/100cqw,26px/100cqh))" }
      }, [
        o("path", { d: "m7.853 18.203 10.35-10.35M7.853 7.853l10.35 10.35" })
      ])
    ], -1)
  ])]);
}
const Yn = { render: Ae }, je = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26"
};
function Le(n, t) {
  return e(), r("svg", je, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.522 16.176V9.504l6.485 3.346zm14.239-7.824s-.234-1.638-.954-2.358a3.46 3.46 0 0 0-2.406-1.004c-3.36-.24-8.397-.24-8.397-.24h-.01s-5.04 0-8.397.24a3.46 3.46 0 0 0-2.403 1.004c-.72.72-.954 2.358-.954 2.358a36 36 0 0 0-.24 3.84v1.8q.015 1.927.24 3.84s.234 1.637.954 2.357c.912.946 2.112.916 2.646 1.015 1.92.182 8.16.24 8.16.24s5.044-.008 8.4-.248a3.46 3.46 0 0 0 2.406-1.005c.72-.72.954-2.357.954-2.357q.225-1.913.24-3.84v-1.8a36 36 0 0 0-.239-3.842"
    }, null, -1)
  ])]);
}
const t6 = { render: Le }, Fe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function be(n, t) {
  return e(), r("svg", Fe, [...t[0] || (t[0] = [
    s('<g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linejoin="round" data-icon-stroke="" style="--icon-sw:1px;stroke-width:calc(1px*max(26px/100cqw,26px/100cqh));"><g stroke-width="1.5" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"><path d="M2.724 14.61a9.063 9.063 0 1 0 16.681-7.09 9.063 9.063 0 0 0-16.68 7.09ZM17.473 17.473l7.029 7.03"></path></g><g stroke-linecap="round" stroke-width="1.5" data-icon-stroke="" style="--icon-sw:1.5px;stroke-width:calc(1.5px*max(26px/100cqw,26px/100cqh));"><path d="M6.673 11h8.654M11 6.673v8.654"></path></g></g>', 1)
  ])]);
}
const o6 = { render: be }, Se = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 26",
  style: { "container-type": "size", "aspect-ratio": "26/26", "--icon-vw": "26px", "--icon-vh": "26px" }
};
function De(n, t) {
  return e(), r("svg", Se, [...t[0] || (t[0] = [
    o("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "data-icon-stroke": "",
      style: { "--icon-sw": "1.5px", "stroke-width": "calc(1.5px*max(26px/100cqw,26px/100cqh))" }
    }, [
      o("g", { "fill-rule": "evenodd" }, [
        o("path", { d: "M2.724 14.61a9.063 9.063 0 1 0 16.681-7.09 9.063 9.063 0 0 0-16.68 7.09ZM17.473 17.473l7.029 7.03" })
      ]),
      o("path", {
        "stroke-linecap": "square",
        d: "M6.673 11h8.654"
      })
    ], -1)
  ])]);
}
const e6 = { render: De };
export {
  Ee as AddIcon,
  Ge as AiIcon,
  Oe as AlertCircleIcon,
  Pe as AlertIcon,
  Re as AlertSolidIcon,
  We as AmexIcon,
  Te as AppWindowIcon,
  Ue as AppleIcon,
  Ne as ApprovalsIcon,
  Qe as ArchivedFilledIcon,
  Je as ArchivedIcon,
  Ke as ArrowLeftIcon,
  Xe as ArrowLeftLinkIcon,
  Ye as ArrowRightLinkIcon,
  tr as ArrowSelectIcon,
  or as ArrowSubsetIcon,
  er as ArrowUpIcon,
  rr as AttachmentIcon,
  nr as AuthorIcon,
  sr as BankIcon,
  lr as BarChartIcon,
  ir as BassIcon,
  cr as BellAlertIcon,
  ar as BellAlertRedIcon,
  hr as BellFilledIcon,
  pr as BellIcon,
  dr as BookmarkIcon,
  xr as CalendarIcon,
  wr as CameraIcon,
  vr as CheckboxIcon,
  ur as CheckboxSelectedIcon,
  kr as CheckedIcon,
  Mr as CheckedSmallSolidIcon,
  fr as CheckedSolidIcon,
  gr as ChecklistIcon,
  zr as CheckmarkIcon,
  _r as ChevronDownIcon,
  mr as ChevronLeftIcon,
  yr as ChevronRightIcon,
  Cr as ChevronUpIcon,
  qr as ChromeIcon,
  $r as ClockIcon,
  Br as CloseIcon,
  jr as CoOwnerIcon,
  Ir as CodeIcon,
  Vr as CollapseIcon,
  Hr as ComputerIcon,
  Ar as ContactCardIcon,
  Lr as CopyIcon,
  Fr as CreatedIcon,
  br as CreditCardIcon,
  Sr as CurrenciesIcon,
  Dr as DacrAIIcon,
  Zr as DacrIcon,
  Er as DacrLicenseIcon,
  Gr as DacrMarkIcon,
  Or as DatabaseIcon,
  Pr as DisableIcon,
  Rr as DiscoverIcon,
  Wr as DownloadIcon,
  Ur as DragDropIcon,
  Nr as DrumsIcon,
  Tr as EmbedIcon,
  Qr as ExpandIcon,
  Jr as ExternalLinkIcon,
  Kr as EyeClosedIcon,
  Xr as EyeOpenIcon,
  Yr as EyeOpenSmallIcon,
  t5 as FacebookIcon,
  o5 as FileAddFilledIcon,
  e5 as FileAddIcon,
  r5 as FileDocketFilledIcon,
  n5 as FileDocketIcon,
  s5 as FileIssueIcon,
  l5 as FileLicenseIcon,
  i5 as FileReassignIcon,
  c5 as FileSearchIcon,
  a5 as FileSellIcon,
  h5 as FileTextIcon,
  p5 as FilterIcon,
  d5 as FlagIcon,
  x5 as FolderAddIcon,
  w5 as FolderIcon,
  v5 as GearIcon,
  u5 as GeneralIcon,
  k5 as GlobeAddIcon,
  M5 as GlobeIcon,
  f5 as GoogleIcon,
  g5 as GooglePlayIcon,
  z5 as GuitarElectricIcon,
  _5 as GuitarIcon,
  m5 as HelpIcon,
  y5 as HomeFilledIcon,
  C5 as HomeIcon,
  q5 as ImageIcon,
  $5 as InfoIcon,
  B5 as InfoSmallIcon,
  I5 as InfringementReportIcon,
  V5 as InstagramIcon,
  H5 as LanguageIcon,
  A5 as LegalIcon,
  j5 as LicenseAddOnIcon,
  L5 as LightbulbIcon,
  b5 as LinkIcon,
  S5 as LinkWebsiteArrowIcon,
  D5 as LinkWebsiteDownloadIcon,
  F5 as LinkedinIcon,
  Z5 as LocationIcon,
  E5 as LockIcon,
  G5 as LockSmallIcon,
  O5 as LockUnlockedIcon,
  P5 as MailIcon,
  R5 as MastercardIcon,
  W5 as MenuBurgerIcon,
  U5 as MenuIcon,
  N5 as MinusIcon,
  T5 as MoveIcon,
  Q5 as MusicNoteIcon,
  J5 as NoIcon,
  K5 as OrganizationIcon,
  X5 as PaintbrushIcon,
  Y5 as PauseIcon,
  tn as PencilIcon,
  on as PhoneIcon,
  en as PhotoIcon,
  rn as PhotosAddIcon,
  nn as PianoIcon,
  sn as PieChart0125Icon,
  ln as PieChart0375Icon,
  cn as PieChart0625Icon,
  an as PieChart0875Icon,
  hn as PlayIcon,
  pn as ProfileIcon,
  dn as QrCodeIcon,
  xn as RefreshIcon,
  wn as ResetRestrictionsIcon,
  vn as ReturnIcon,
  un as SearchIcon,
  kn as SellIcon,
  Mn as SendIcon,
  fn as ShareIcon,
  gn as ShieldWarningIcon,
  zn as SignOutIcon,
  _n as SmallGlobeIcon,
  mn as SmallOrganizationIcon,
  yn as SortIcon,
  Cn as Split3WayIcon,
  qn as StringsIcon,
  $n as SyncCircleIcon,
  Bn as SyncIcon,
  In as SynthesizerIcon,
  Vn as TabletIcon,
  Hn as TeamIcon,
  An as TextIcon,
  jn as ThumbsUpIcon,
  Ln as TrashIcon,
  Fn as TwitterIcon,
  bn as TypingIcon,
  Sn as UnlistedIcon,
  Dn as UpgradeIcon,
  Zn as UploadIcon,
  En as VerifiedDefaultIcon,
  Gn as VideoCameraIcon,
  On as VideoIcon,
  Pn as VisaIcon,
  Rn as VocalAndInstrumentalIcon,
  Wn as VoiceAndNoiseIcon,
  Un as VolumeHighIcon,
  Nn as VolumeLowIcon,
  Tn as VolumeOffIcon,
  Qn as WindIcon,
  Jn as WindowsIcon,
  Kn as WritingIcon,
  Xn as XIcon,
  Yn as XSolidIcon,
  t6 as YoutubeIcon,
  o6 as ZoomInIcon,
  e6 as ZoomOutIcon
};
